import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, takeUntil } from "rxjs";
import { AppModuleComponent } from "../interfaces/appmodules";
import { ComponentTool } from "../interfaces/componenttool";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { AutoRemoteResetCommandConfig } from "../interfaces/autoremoteresetcommandconfig";
import { KpiApprovalScope } from "../interfaces/kpiapprovalscope";
import { Editgroupfunctionsdialogue } from "../components/usermngportal/home/edituser/usermgmtbranch/editgroupfunctionsdialogue/editgroupfunctionsdialogue.component";

const API_BUSINESS_KEY = "api/businesskey/";
const API_LOG = "api/log/";
const API_ELEVATOR = "api/elevator/";
const API_ESCALATOR = "api/escalator/";
const API_OTHERASSET = "api/otherassets/";
const API_CONTROLLER_TYPE = "api/controllertype/";
const API_ERROR_CODE = "api/errorcode/";
const API_GENERIC = "api/generic/";
const API_HOME = "api/home/";
const API_MAINTENANCE_CONTROL_PLAN = "api/maintenancecontrolplan/";
const API_MAINTENANCE_WARNING = "api/maintenancewarning/";
const API_FINGERPRINT = "api/fingerprintrule/";
const API_BRANCHHIERARCHY = "api/branchhierarchy";
const API_KPIPRODUCTHIERARCHY = "api/kpiproducthierarchy";
const API_LANGUAGE = "api/language/";
const API_OPERATION_MODE = "api/operationmode/";
const API_TEST_CASE = "api/testcase/";
const API_TRANSLATION_AREA = "api/translationarea/";
const API_COUNTRY = "api/country/";
const API_ORGHIERARCHY = "api/orghierarchy";
const API_ALERTRULE = "api/alertrule";
const API_EXPORTIMPORT = "api/ImportExportModel/";
const API_AZUREDATAFACTORY = "api/AzureDataFactory/";
const API_BUILDRELEASE = "api/buildrelease/";
const API_HEALTHSCORE = "api/healthscore";
const API_DIGITALSERVICES = "api/digitalservices";



//CDP SEPE 06/2022
const API_CDP_CONTROLLER_TYPE_MAPPING = "api/controllertypemapping/";

//Default Transmision Mode SEPE 06/2022
const API_TRANSMISSION_MODE_CONFIGURATION = "api/transmissionmodeconfiguration";
const API_MASTER_ALERT_WINDOW = "api/AlertWindow";

// Allen
const API_CLAIMS = "api/generic/Claims/";
const API_TENANT = "api/tenant/";


// UMP
const API_UMPUSER = "api/user"
const API_Wiki = "api/wiki"
const API_MERSY_KPI_GROUP_FUNCTION = "api/MersyKpiGroupFunction"

const EXCEL_FILEUPLOAD_ERRORCODES = 0;
const EXCEL_FILEUPLOAD_OPMODES = 1;
const EXCEL_FILEUPLOAD_CONTRACTS = 2;
const EXCEL_FILEUPLOAD_CUSTOMERS = 3;
const EXCEL_FILEUPLOAD_ELEVATORS = 4;
const EXCEL_FILEUPLOAD_ESCALATORS = 5;
const EXCEL_FILEUPLOAD_BRANCHHIERARCHY = 6;
const EXCEL_FILEUPLOAD_SERVICETICKETS = 7;
const EXCEL_FILEUPLOAD_CHAIRLIFTS = 8;
const EXCEL_FILEUPLOAD_OTHERASSETS = 9;
const EXCEL_FILEUPLOAD_CONTRACTFACILITYMANAGER = 10;
const EXCEL_FILEUPLOAD_CUSTOMERFACILITYMANAGER = 11;
const EXCEL_FILEUPLOAD_KPI = 12;
const EXCEL_FILEUPLOAD_ERRORCODESDIGITALSERVICES = 13;
const EXCEL_FILEUPLOAD_CONFIGIT = 14;
const EXCEL_FILEUPLOAD_ACTUALREPORTING = 15;
const EXCEL_FILEUPLOAD_OPLYEARLY = 16;
const EXCEL_FILEUPLOAD_OPLMONTHLY = 17;
const EXCEL_FILEUPLOAD_ACTUALBRANCHREPORTING = 18;
const EXCEL_FILEUPLOAD_OPLYEARLYBRANCHREPORTING = 19;
const EXCEL_FILEUPLOAD_OPLMONTHLYBRANCHREPORTING = 20;
const EXCEL_FILEUPLOAD_MARKET_SHEET = 21;
const EXCEL_FILEUPLOAD_SEGMENT_SHEET = 22;
const EXCEL_FILEUPLOAD_EXCELLENCE_LEVER = 23;
const EXCEL_FILEUPLOAD_EXCELLENCE_LEVER_KPI = 24;
const EXCEL_FILEUPLOAD_EXCELLENCE_Factor = 25;
const EXCEL_FILEUPLOAD_ASSESSMENT_CONF = 26;
const EXCEL_FILEUPLOAD_NIOPS = 27;
const EXCEL_FILEUPLOAD_TRANSL_LEVER = 28;
const EXCEL_FILEUPLOAD_TRANSL_Factor = 29;
const EXCEL_FILEUPLOAD_FOCUSPLANSTATUS = 30;
const EXCEL_FILEUPLOAD_FOCUSPLANDEFINITION = 31;
const EXCEL_FILEUPLOAD_IMPROV_LEVERS = 32;
const EXCEL_FILEUPLOAD_CUSTOMERDOCUMENTS = 33;
const EXCEL_FILEUPLOAD_INSPECTIONS = 34;
const EXCEL_FILEUPLOAD_CONTACTS = 35;
const EXCEL_FILEUPLOAD_CONTACTTOUNITS = 36;
const EXCEL_FILEUPLOAD_TAXACTUALREPORTING = 37;
const EXCEL_FILEUPLOAD_TAXOPLYEARLY = 38;
const EXCEL_FILEUPLOAD_FINANCIALIMPACT = 39;
const EXCEL_FILEUPLOAD_OSH_PROTOCOL_FACTORS = 40;
const EXCEL_FILEUPLOAD_OSH_PROTOCOL_FACTORS_TRANSL = 41;
const EXCEL_FILEUPLOAD_OSH_ASSESSMENTS = 42;

const EXCEL_FILEUPLOAD_INCOACTUALREPORTING = 43;
const EXCEL_FILEUPLOAD_INCOOPLREPORTING = 44;
const EXCEL_FILEUPLOAD_WAVE_BRANCH_DATA = 45;



const API_INFOHUB = "api/countrybackend/infohub/"
const API_EVENTARCHIVE = "api/countrybackend/eventarchive/"
const API_CONFIGURATION = "api/countrybackend/configuration/"
const API_CDPWIKI = "api/countrybackend/wiki/"
const API_SETUP = "api/countrybackend/setup/"
const API_CONTRACTBUNDLE = "api/countrybackend/contractbundle/"
const API_AUDIT = "api/CountryBackend/audit/";

const API_REMOTEACTIONS = "api/remoteaction/";
const API_VIRTUALPROVISIONING = "api/virtualprovisioning"

const API_GROUPFUNCTION = 'api/groupfunction'
const API_MANAGEMENTID = 'api/managementid'
const API_FISCALYEAR = 'api/fiscalyear'
const API_PERIOD = 'api/period'
const API_KPIMANAGEMENT = 'api/kpimanagement'
const API_MARKETQUERY = 'api/marketquery'
const API_BRANCHEXCELLENCE = 'api/branchexcellence'
const API_OSH = 'api/osh'
const API_NIOPSREPORTING = 'api/niopsreporting'
const API_EMT = 'api/equipmentmanagement'
const API_JCOB = 'api/JCOB'
const API_GLOBALTASKLIST = 'api/globaltasklist'
const API_Quarter = 'api/Quarter'
const API_TAX = 'api/Tax';
const API_INCO = 'api/Inco';
const API_DEPLOYMENT = 'api/deployment';

const NOT_TRANSLATED_CLASSNAME = "not-translated";

/************************************************
 *      constant for default language
 * */
const DEFAULT_LANGUAGE_ID = 50;

/************************************************
 *      constant for editing classname
 * */
const EDITING_INPUT_CLASSNAME = "editing";

/**
 * id for status server error code exception
 * */
const STATUS_SERVER_ERROR_CODE = 509;
const UNAUTHORIZED_SERVER_ERROR = 401;

/************************************************
 *      constant for default controller type
 * */
const DEFAULT_CONTROLLERTYPE_ID = 32;

/************************************************
 *      constants for alert confirm div
 * */
const SUCCESS = 0;
const ERROR = 1;
const WARNING = 2;
const CONFIRM = 3;
const INFO_BACKGROUND = 4;

/************************************************
 *      Message types
 * */
const BLUEBOX_MESSAGE_TYPE = 4;
const DOOR_MOVEMENT_MESSAGE_TYPE = 40;
const ERROR_CODE_MESSAGE_TYPE = 51;
const OPERATION_MODE_MESSAGE_TYPE = 52;
const TRIP_MESSAGE_TYPE = 69;
const CONTROLLER_MESSAGE_TYPE = 60;

/************************************************
 *      Schema Keys
 * */
const START_FLOOR_SCHEMA_KEY = 13;
const END_FLOOR_SCHEMA__KEY = 14;
const DOOR_START_STATE_SCHEMA_KEY = 15;
const DOOR_END_STATE_SCHEMA_KEY = 16;
const ID_SCHEMA_KEY = 22;
const DOOR_FLOOR_SCHEMA_KEY = 29;

const STABLE_STAGE = '0'
const PRODUCTION_STAGE = '1';
const DEV_STAGE = '2';

export const API_ROUTES = {
    API_EMT,
    API_BRANCHHIERARCHY,
    API_BUILDRELEASE,
    API_KPIMANAGEMENT,
    API_TAX,
    API_BRANCHEXCELLENCE,
    API_INCO,
    API_DEPLOYMENT
};


export const Session = {
    ControllerType: DEFAULT_CONTROLLERTYPE_ID
    , LanguageID: DEFAULT_LANGUAGE_ID
}

export enum BusinessKeyTypes {
    BrakeType = 2,
    BuildingType = 3,
    ControllerType = 4,
    DoorType = 5,
    DriveType = 6,
    ElevatorType = 7,
    MachineRoomLocation = 8,
    MotorType = 9,
    ReevingRatioType = 10,
    ValveType = 11,
    WrappingType = 12,
    Manufacturer = 25,
    LoadSpectrum = 26,
    Series = 27,
    BalustradeType = 28,
    AngleInclination = 29,
    Width = 30,
    ClimatClass = 31,
    Embarquement = 32,
    Code = 33,
    BlueBox = 51,
    DoorState = 55
}

export enum UMPCategory {
    None = -1,
    UserDetails = 0,
    SpecialPermissions = 1,
    AssignedLicenses = 2,
    DevOpsProjectAreas = 3,
    MaxRoles = 4,
    EmtRoles = 5,
    HomeRoles = 6,
    MersyRoles = 7,
    MersyGroupFunctions = 8,
    DAnalyticsPowerBI = 9,
    BranchHierarchy = 10,
    MgmtBranchHierarchy = 11,
    UserManagement = 12,
    MfgRoles = 13,
    ExternalUserCreate = 14,
    MarketLineOfBusiness = 15,
    MarketProductType = 16,
    PEReportingRole = 17,
    MersyKPIGroupFunction = 18,
    CDPHierarchy = 19,
    C360Groups = 20,
}

export enum UMPAction {
    Create = 0,
    Delete = 1,
    Update = 2,
    Assign = 3,
    Unassign = 4,
    Reset = 5,
    Clear = 6
}

export enum EmailSearchfor {
    SearchOnly = 0,
    UserCreation = 1,
}

export enum APICallStatus {
    NotRequested = -3,
    Waiting4Response = -2,
    ResponseError = -1,
    ResponseEmptyOk = 0,
    ResponseDataOk = 1
}

export enum ConfigurationKeyEnumType {
    NoConsequence = 0,
    Shutdown = 1,
}

export enum BuildReleaseType {
    OperationModes = 0,
    ErrorCodes = 1,
    TdcEmt = 2,
    GlobalTaskList = 3
}

export enum EmtUpdateMandatoryPeripheralVersionResponseType {
  Success = 0,
  NotModfied = 1,
  Conflict = 2,
  NotFound = 3,
  UnknownError = 4,
  EmptyRequest = 5
}

export enum LevelHierarchyDepth {
    Environment = 1,
    Tenant = 2,
    Branch = 3,
    Device = 4
}

export class Utils {

    public static getFileUploadIncoActualReportingInformation(): number { return EXCEL_FILEUPLOAD_INCOACTUALREPORTING; }
    public static getFileUploadIncoOplReportingInformation(): number { return EXCEL_FILEUPLOAD_INCOOPLREPORTING; }
    public static getBlueBoxMessageTypeValue(): number { return BLUEBOX_MESSAGE_TYPE; }

    public static getBusinessKeyAPI(): string { return API_BUSINESS_KEY; }

    public static getConfirmValue(): number { return CONFIRM; }

    public static getControllerTypeAPI(): string { return API_CONTROLLER_TYPE; }

    public static getControllerTypeMessageTypeValue(): number { return CONTROLLER_MESSAGE_TYPE; }

    public static getDefaultControllerTypeID(): number { return DEFAULT_CONTROLLERTYPE_ID; }

    public static getDefaultLaguangeID(): number { return DEFAULT_LANGUAGE_ID; }

    public static getDialogHideClassName(): string { return "hide"; }

    public static getDialogShowClassName(): string { return "dialog"; }

    public static getDoorEndStateSchemaKey(): number { return DOOR_END_STATE_SCHEMA_KEY; }

    public static getDoorFloorSchemaKey(): number { return DOOR_FLOOR_SCHEMA_KEY; }

    public static getDoorMovementMessageTypeValue(): number { return DOOR_MOVEMENT_MESSAGE_TYPE; }

    public static getDoorStartStateSchemaKey(): number { return DOOR_START_STATE_SCHEMA_KEY; }

    public static getEditingInputClassName(): string { return EDITING_INPUT_CLASSNAME; }

    public static getEndFloorSchemaKey(): number { return END_FLOOR_SCHEMA__KEY; }

    public static getErrorCodeAPI(): string { return API_ERROR_CODE; }

    public static getErrorMessageTypeValue(): number { return ERROR_CODE_MESSAGE_TYPE; }

    public static getErrorValue(): number { return ERROR; }

    public static getInfoBackgroundValue(): number { return INFO_BACKGROUND; }

    public static getFileUploadErrorCodeValue(): number { return EXCEL_FILEUPLOAD_ERRORCODES; }

    public static getFileUploadOpModeValue(): number { return EXCEL_FILEUPLOAD_OPMODES; }

    public static getFileUploadContracts(): number { return EXCEL_FILEUPLOAD_CONTRACTS; }

    public static getFileUploadCustomers(): number { return EXCEL_FILEUPLOAD_CUSTOMERS; }

    public static getFileUploadElevators(): number { return EXCEL_FILEUPLOAD_ELEVATORS; }

    public static getFileUploadEscalators(): number { return EXCEL_FILEUPLOAD_ESCALATORS; }

    public static getFileUploadBranchHierarchy(): number { return EXCEL_FILEUPLOAD_BRANCHHIERARCHY; }

    public static getFileUploadServiceTickets(): number { return EXCEL_FILEUPLOAD_SERVICETICKETS; }

    public static getFileUploadChairlifts(): number { return EXCEL_FILEUPLOAD_CHAIRLIFTS; }

    public static getFileUploadOtherAssets(): number { return EXCEL_FILEUPLOAD_OTHERASSETS; }

    public static getFileUploadContractFacilitiesManager(): number { return EXCEL_FILEUPLOAD_CONTRACTFACILITYMANAGER; }

    public static getFileUploadCustomerFacilitiesManager(): number { return EXCEL_FILEUPLOAD_CUSTOMERFACILITYMANAGER; }

    public static getFileKpi(): number { return EXCEL_FILEUPLOAD_KPI; }

    public static getFileUploadCustomerDocument(): number { return EXCEL_FILEUPLOAD_CUSTOMERDOCUMENTS; }

    public static getFileUploadInspection(): number { return EXCEL_FILEUPLOAD_INSPECTIONS; }

    public static getFileUploadContacts(): number { return EXCEL_FILEUPLOAD_CONTACTS; }

    public static getFileContactToUnit(): number { return EXCEL_FILEUPLOAD_CONTACTTOUNITS; }

    public static getFileUploadErrorCodesDigitalServices(): number { return EXCEL_FILEUPLOAD_ERRORCODESDIGITALSERVICES; }

    public static getFileUploadConfigIt(): number { return EXCEL_FILEUPLOAD_CONFIGIT; }

    public static getFileUploadActualReportingInformation(): number { return EXCEL_FILEUPLOAD_ACTUALREPORTING; }

    public static getFileUploadOplYearlyInformation(): number { return EXCEL_FILEUPLOAD_OPLYEARLY; }

    public static getFileUploadOplMonthlyInformation(): number { return EXCEL_FILEUPLOAD_OPLMONTHLY; }

    public static getFileUploadActualBranchReportingInformation(): number { return EXCEL_FILEUPLOAD_ACTUALBRANCHREPORTING; }

    public static getFileUploadOplYearlyBranchReportingInformation(): number { return EXCEL_FILEUPLOAD_OPLYEARLYBRANCHREPORTING; }

    public static getFileUploadOplMonthlyBranchReportingInformation(): number { return EXCEL_FILEUPLOAD_OPLMONTHLYBRANCHREPORTING; }

    public static getFileUploadMarketSheet(): number { return EXCEL_FILEUPLOAD_MARKET_SHEET; }
    public static getFileUploadAssessmentConf(): number { return EXCEL_FILEUPLOAD_ASSESSMENT_CONF; }

    public static getFileUploadSegmentSheet(): number { return EXCEL_FILEUPLOAD_SEGMENT_SHEET; }
    public static getFileUploadExcellenceLever(): number { return EXCEL_FILEUPLOAD_EXCELLENCE_LEVER; }
    public static getFileUploadTranslLever(): number { return EXCEL_FILEUPLOAD_TRANSL_LEVER; }
    public static getFileUploadExcellenceLeverKPI(): number { return EXCEL_FILEUPLOAD_EXCELLENCE_LEVER_KPI; }
    public static getFileUploadExcellenceFactor(): number { return EXCEL_FILEUPLOAD_EXCELLENCE_Factor; }
    public static getFileUploadTranslFactor(): number { return EXCEL_FILEUPLOAD_TRANSL_Factor; }
    public static getFileUploadFocusPlanStatus(): number { return EXCEL_FILEUPLOAD_FOCUSPLANSTATUS; }
    public static getFileUploadFocusPlanDefinition(): number { return EXCEL_FILEUPLOAD_FOCUSPLANDEFINITION; }
    public static getFileUploadImprovementLevers(): number { return EXCEL_FILEUPLOAD_IMPROV_LEVERS; }
    public static getFileUploadWaveBranchData(): number { return EXCEL_FILEUPLOAD_WAVE_BRANCH_DATA; }
    public static getFileUploadNiOps(): number { return EXCEL_FILEUPLOAD_NIOPS; }
    public static getFileUploadTaxActualReportingInformation(): number { return EXCEL_FILEUPLOAD_TAXACTUALREPORTING; }
    public static getFileUploadTaxOplYearlyInformation(): number { return EXCEL_FILEUPLOAD_TAXOPLYEARLY; }
    public static getFileUploadFocusPlanFinancialImpact(): number { return EXCEL_FILEUPLOAD_FINANCIALIMPACT; }

    public static getFileUploadOshProtocols(): number { return EXCEL_FILEUPLOAD_OSH_PROTOCOL_FACTORS; }
    public static getFileUploadOshProtocolsTransl(): number { return EXCEL_FILEUPLOAD_OSH_PROTOCOL_FACTORS_TRANSL; }
    public static getFileUploadOshAssessments(): number { return EXCEL_FILEUPLOAD_OSH_ASSESSMENTS; }

    public static getGenericAPI(): string { return API_GENERIC; }

    public static getHomeAPI(): string { return API_HOME; }

    public static getIdSchemaKey(): number { return ID_SCHEMA_KEY; }

    public static getLanguageAPI(): string { return API_LANGUAGE; }

    public static getMaintenanceControlPlanAPI(): string { return API_MAINTENANCE_CONTROL_PLAN; }

    public static getMaintenanceWarningAPI(): string { return API_MAINTENANCE_WARNING; }

    public static getNotTranslatedClassName(): string { return NOT_TRANSLATED_CLASSNAME; }

    public static getOpacityClassName(): string { return "opacity"; }

    public static getOperationModeMessageTypeValue(): number { return OPERATION_MODE_MESSAGE_TYPE; }

    public static getOperationModeAPI(): string { return API_OPERATION_MODE; }

    //public static getSelectedControllerType(): ControllerType { return this.controllertype; }

    //public static getSelectedLanguage(): Language { return this.language; }

    public static getStartFloorSchemaKey(): number { return START_FLOOR_SCHEMA_KEY; }

    public static getStatusServerError(): number { return STATUS_SERVER_ERROR_CODE; }

    public static getSuccessValue(): number { return SUCCESS; }

    public static getTestCaseAPI(): string { return API_TEST_CASE; }

    public static getTripMessageTypeValue(): number { return TRIP_MESSAGE_TYPE; }

    public static getWaitingClassName(): string { return "waiting"; }

    public static getWarningValue(): number { return WARNING; }

    public static getAzureDataFactory(): string { return API_AZUREDATAFACTORY; }

    public static getBackendSetup(): string { return API_SETUP; }

    public static getElevatorAPI(): string { return API_ELEVATOR; }

    public static getEscalatorAPI(): string { return API_ESCALATOR; }

    public static getCDPControllerTypeMappingAPI(): string { return API_CDP_CONTROLLER_TYPE_MAPPING; }

    public static getRemoteActionAPI(): string { return API_REMOTEACTIONS; }
    // Allen
    public static getClaimsAPI(): string { return API_CLAIMS; }

    public static getTenantAPI(): string { return API_TENANT; }

    public static getFingerprintAPI(): string { return API_FINGERPRINT; }

    public static getBranchHierarchyAPI(): string { return API_BRANCHHIERARCHY; }

    public static getVirtualProvisioningAPI(): string { return API_VIRTUALPROVISIONING; }

    // External databases

    public static getInfoHubAPI(): string { return API_INFOHUB; }

    public static getEventArchiveAPI(): string { return API_EVENTARCHIVE; }

    // SEPE 06/2022
    public static getTransmissionModeConfigurationAPI(): string { return API_TRANSMISSION_MODE_CONFIGURATION; }

    public static getMasterAlertWindowAPI(): string { return API_MASTER_ALERT_WINDOW; }

    public static getStableEnvironment(): string { return STABLE_STAGE; }

    public static getProductionEnvironment(): string { return PRODUCTION_STAGE; }

    public static getDevEnvironment(): string { return DEV_STAGE; }

    //SEPE 11/2022
    public static getAPIFingerPrint(): string { return API_FINGERPRINT; }

    public static getGroupFunctionAPI(): string { return API_GROUPFUNCTION; }

    public static getManagementIdAPI(): string { return API_MANAGEMENTID; }

    public static getFiscalYearAPI(): string { return API_FISCALYEAR; }

    public static getPeriodAPI(): string { return API_PERIOD; }

    public static getKpiManagementAPI(): string { return API_KPIMANAGEMENT; }

    public static getMarketQueryAPI(): string { return API_MARKETQUERY; }

    public static getBranchExcellenceAPI(): string { return API_BRANCHEXCELLENCE; }

    public static getOshAPI(): string { return API_OSH; }

    public static getNiOpsReportingAPI(): string { return API_NIOPSREPORTING; }

    public static getGlobalTaskListAPI(): string { return API_GLOBALTASKLIST; }

    // UMP ENDPOINT
    public static getUMPUser(): string { return API_UMPUSER; }
    public static getWiki(): string { return API_Wiki; }
    public static getMersyKPIGroupFunction(): string { return API_MERSY_KPI_GROUP_FUNCTION; }

    // EMT ENDPOINT
    public static getEMTAPI(): string { return API_EMT; }

    //JCOB ENDPOINT
    public static getJCOBAPI(): string { return API_JCOB; }

    public static getQuarter(): string { return API_Quarter; }
    public static getTAXAPI(): string { return API_TAX; }

    //AUTO REMOTE RESET COMMAND ENDPOINT
    public static getAutoRemoteResetCommandAPI(): string { return API_REMOTEACTIONS + "autoremoteresetcommandconfig"; }

    public static getDeploymentAPI(): string { return API_DEPLOYMENT; }

    ///**
    // * hide the dialog
    // * 
    // * @param tthis
    // * @deprecated
    // */
    //public static hideDialog(tthis: any) {
    //    tthis.classdialog = this.getDialogHideClassName();
    //    tthis.defaults.classname = tthis.classname = "";
    //}

    public static getClusterComponent(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + API_GENERIC + "appmodules/" + Utils.getDomainByWindowLocation();;
        http.get<AppModuleComponent>(url).toPromise().then(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });

    }

    public static getRegions(http: HttpClient, baseUrl: string): Observable<OrgHierarchy[]> {
        const url = baseUrl + API_ORGHIERARCHY + "/regions";
        return http.get<OrgHierarchy[]>(url);

    }

    public static getAllBranches(http: HttpClient, baseUrl: string): Observable<OrgHierarchy[]> {
        const url = baseUrl + API_ORGHIERARCHY + "/branches";
        return http.get<OrgHierarchy[]>(url);

    }

    public static getBranches(http: HttpClient, baseUrl: string, region: string): Observable<OrgHierarchy[]> {
        const url = baseUrl + API_ORGHIERARCHY + "/branches/" + region;
        return http.get<OrgHierarchy[]>(url);

    }

    public static getBusinessKeyLookups(http: HttpClient, baseUrl: string, businessKeyType: BusinessKeyTypes): Observable<BusinessKey[]> {
        const url = baseUrl + API_BUSINESS_KEY + "all/" + businessKeyType;
        return http.get<BusinessKey[]>(url);

    }

    public static httpGetAllAssetTypes(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) { //: Observable<Country[]> {
        const url = baseUrl + API_CONTROLLER_TYPE + "assettype";
        return http.get<AssetType[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }

    public static httpGetAllBusinessKeys(http: HttpClient, baseUrl: string, TranslationAreaID: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_BUSINESS_KEY + "all/" + TranslationAreaID;
        http.get<BusinessKey[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpDownloadOperationModes(http: HttpClient, baseUrl: string, controllerType: string, tthis: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + 'download/operationmodes/operation-modes';
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, "OperationModes_" + controllerType, "xlsx")
        }, (error: any) => {
            tthis.onError(error);
        })
    }

    public static httpDownloadErrorCodes(http: HttpClient, baseUrl: string, controllerType: string, tthis: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + 'download/errorcodes/error-codes';
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, "ErrorCodes_" + controllerType, "xlsx")
        }, (error: any) => {
            tthis.onError(error);
        })
    }

    public static httpDownloadBusinessKeys(http: HttpClient, baseUrl: string, TranslationAreaID: number, translationAreaName: string) {
        const url = baseUrl + API_EXPORTIMPORT + 'download/businesskeys/' + TranslationAreaID;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, "BusinessKeys_" + translationAreaName, "xlsx")
        })
    }

    public static httpDownloadMarketQuery(http: HttpClient, baseUrl: string, file_name: string, maketQueryType: 'MARKET' | 'SEGMENT') {
        const url = `${baseUrl}${API_EXPORTIMPORT}download/marketquery/${maketQueryType}`;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, file_name, "xlsx"),
                (error: any) => {
                    Utils.writeLog(http, baseUrl, error);
                }
        });
    }
    public static httpDownloadAssessmentConf(http: HttpClient, baseUrl: string, file_name: string, Waveid: number, Mgmtid: string) {
        const url = `${baseUrl}${API_EXPORTIMPORT}download/assessmentconf/${Waveid}/${Mgmtid}`;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, file_name, "xlsx"),
                (error: any) => {
                    Utils.writeLog(http, baseUrl, error);
                }
        });
    }
    public static httpDownloadIncoActualReporting(
        http: any,
        baseUrl: string,
        file_name: string,
        managementId: string | number,
        fiscalYear: number,
        quarter: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined = undefined
    ) {
        const url = `${baseUrl}${API_EXPORTIMPORT}download/incoactualreporting/${managementId}/${fiscalYear}/${quarter}`;
        http.get(url, { responseType: 'blob' }).subscribe({
            next: (response: any) => {
                this.downloadFile(response, file_name, "xlsx");
                if (callback) callback(tthis, response);
            },
            error: (error: any) => {
                Utils.writeLog(http, baseUrl, error);
                if (callbackError) callbackError(tthis, error);
            }
        });
    }
    public static httpDownloadIncoOplReporting(
        http: any,
        baseUrl: string,
        file_name: string,
        managementId: string | number,
        fiscalYear: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined = undefined
    ){
        const url = `${baseUrl}${API_EXPORTIMPORT}download/incooplreporting/${managementId}/${fiscalYear}`;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, file_name, "xlsx");
            if (callback) callback(tthis, response);
        }, (error: any) => {
            Utils.writeLog(http, baseUrl, error);
            if (callbackError) callbackError(tthis, error);
        });
    }
    public static httpDownloadExcellenceFactors(http: HttpClient, baseUrl: string, file_name: string, ItemType: string) {
        const url = `${baseUrl}${API_EXPORTIMPORT}download/excellenceFactor/${ItemType}`;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, file_name, "xlsx"),
                (error: any) => {
                    Utils.writeLog(http, baseUrl, error);
                }
        });
    }
    public static httpDownloadExcellenceFactorsTransl(http: HttpClient, baseUrl: string, file_name: string, ItemType: string) {
        const url = `${baseUrl}${API_EXPORTIMPORT}download/excellenceFactorTransl/${ItemType}`;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, file_name, "xlsx"),
                (error: any) => {
                    Utils.writeLog(http, baseUrl, error);
                }
        });
    }

    public static httpDownloadOshProtocolFactors(http: HttpClient, baseUrl: string, file_name: string) {
        const url = `${baseUrl}${API_EXPORTIMPORT}download/oshProtocolFactors`;
        http.get(url, { responseType: 'blob' }).subscribe({
            next: (response: any) => {
                this.downloadFile(response, file_name, "xlsx");
            },
            error: (error: any) => {
                Utils.writeLog(http, baseUrl, error);
            }
        });
    }

    public static httpDownloadOshProtocolFactorsTransl(http: HttpClient, baseUrl: string, file_name: string) {
        const url = `${baseUrl}${API_EXPORTIMPORT}download/oshProtocolFactorsTransl`;
        http.get(url, { responseType: 'blob' }).subscribe({
            next: (response: any) => {
                this.downloadFile(response, file_name, "xlsx");
            },
            error: (error: any) => {
                Utils.writeLog(http, baseUrl, error);
            }
        });
    }

    public static httpDownloadOshAssessments(http: HttpClient, baseUrl: string, file_name: string, mgmtId: string, waveId: number) {
        const url = `${baseUrl}${API_EXPORTIMPORT}download/oshAssessments/${mgmtId}/${waveId}`;
        http.get(url, { responseType: 'blob' }).subscribe({
            next: (response: any) => {
                this.downloadFile(response, file_name, "xlsx");
            },
            error: (error: any) => {
                Utils.writeLog(http, baseUrl, error);
            }
        });
    }

    public static httpDownloadFocusPlanStatus(http: HttpClient, baseUrl: string, filename: string, waveId: number, mgmtId: string, tthis: any | undefined = undefined, callBackError: any | undefined = undefined) {
        const url = `${baseUrl}${API_EXPORTIMPORT}download/focus-plan/status/${waveId}/${mgmtId}`;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, filename, "xlsx"),
                (error: any) => {
                    Utils.writeLog(http, baseUrl, error);
                    callBackError(tthis, error);
                }
        });
    }

    public static httpDownloadExcelGeneric(http: HttpClient, baseUrl: string, fileUrl: string, filename: string, tthis: any | undefined = undefined, callBackError: any | undefined = undefined) {
        const url = `${baseUrl}${API_EXPORTIMPORT}${fileUrl}`;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, filename, "xlsx"),
                (error: any) => {
                    Utils.writeLog(http, baseUrl, error);
                    callBackError(tthis, error);
                }
        });
    }

    public static httpDownloadImprovementLevers(http: HttpClient, baseUrl: string, file_name: string, Waveid: number) {
        const url = `${baseUrl}${API_EXPORTIMPORT}download/improvement-levers/${Waveid}`;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, file_name, "xlsx"),
                (error: any) => {
                    Utils.writeLog(http, baseUrl, error);
                }
        });
    }

    public static httpDownloadWaveBranchData(http: HttpClient, baseUrl: string, file_name: string, Waveid: number) {
        const url = `${baseUrl}${API_EXPORTIMPORT}download/wave-branch-data/${Waveid}`;
        http.get(url, { responseType: 'blob' }).subscribe({
            next: (response: any) => {
                this.downloadFile(response, file_name, "xlsx");
            },
            error: (error: any) => {
                Utils.writeLog(http, baseUrl, error);
            }
        });
    }

    // CDP SEPE 06/2022
    public static httpGetAllControllerTypeLocal(http: HttpClient, baseUrl: string, filter: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CDP_CONTROLLER_TYPE_MAPPING + "all/" + filter.toString();
        http.get<ControllerTypeMapping[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }


    public static httpGetAllCauses(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_BUSINESS_KEY + "cause";
        http.get<BusinessKeySon[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllChangeLog(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_LOG + "changes";
        tthis.subscriptions.push(http.get<ChangeLog[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        })
        );
    }

    public static httpGetAllControllerDrives(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) { //: Observable<Country[]> {
        const url = baseUrl + API_CONTROLLER_TYPE + "controllerdrive";
        return http.get<ControllerDrive[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }

    public static httpGetAllControllerOwner(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) { //: Observable<Country[]> {
        const url = baseUrl + API_CONTROLLER_TYPE + "controllerowner";
        return http.get<Country[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });

    }
    public static httpGetAllPopulationforController(http: HttpClient, baseUrl: string, controllerBK: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_HEALTHSCORE + "/allPopulation/" + controllerBK;
        return http.get<Population[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }
    public static httpGetDialerNameAndRegulatoryCodes(http: HttpClient, baseUrl: string, tenant: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_DIGITALSERVICES + "/dialerCodes/" + tenant;
        return http.get<any>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            //tthis.getRegCodeForDialer(tthis.selectedDialer);
            Utils.writeLog(http, baseUrl, error);
        });
    }
    public static httpGetRegulatoryCodeBundles(http: HttpClient, baseUrl: string, tenant: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_DIGITALSERVICES + "/regulatoryCodeBundles/" + tenant;
        return http.get<any>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            //tthis.getRegCodeForDialer(tthis.selectedDialer);
            Utils.writeLog(http, baseUrl, error);
        });
    }
    public static httpGetDialerProperties(http: HttpClient, baseUrl: string, queryString: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_DIGITALSERVICES + "/dialerproperties/" + queryString;
        return http.get<any>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            tthis.Response_State = -1;
            Utils.writeLog(http, baseUrl, error);
        });
    }
    public static httpGetDialersAvailableFirmware(http: HttpClient, baseUrl: string, dilaerType: string, regulatoryCode: string | undefined, tthis: any | undefined = undefined, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        let regulatoryCodeQuery = regulatoryCode != undefined ? `/${regulatoryCode}` : "";
        const url = baseUrl + API_DIGITALSERVICES + "/availableFirmware/" + dilaerType + regulatoryCodeQuery;
        return http.get<any>(url).subscribe({
            next: (result: any) => {
                if (tthis && callback)
                    callback(tthis, result);
            },
            error: (error: any) => {
                if (tthis && errorCallback)
                    errorCallback(tthis, error);
            }
        });
    }

    public static httpGetDialerFirmwareAssignmentStatus(http: HttpClient, baseUrl: string, correlationId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        const url = baseUrl + API_DIGITALSERVICES + "/firmwareAssignmentStatus/" + correlationId;
        return http.get<any>(url).subscribe({
            next: (result: any) => {
                if (tthis && callback)
                    callback(tthis, result);
            },
            error: (error: any) => {
                if (tthis && errorCallback)
                    errorCallback(tthis, error);
            }
        });
    }

    public static httpGetTotalAvailableRegulatorycodes(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        const url = baseUrl + API_DIGITALSERVICES + "/totalAvailableRegulatoryCodes";
        return http.get<any>(url).subscribe({
            next: (result: any) => {
                if (tthis && callback)
                    callback(tthis, result);
            },
            error: (error: any) => {
                if (tthis && errorCallback)
                    errorCallback(tthis, error);
            }
        });
    }

    public static httpPutDialerDefaultFirmware(http: HttpClient, baseUrl: string, body: SetDefaultFirmwareVersionBody, tthis: any | undefined = undefined, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        const url = baseUrl + API_DIGITALSERVICES + "/setDefaultFirmware";
        http
            .put<any>(url, body).subscribe({
                next: (result: any) => {
                    if (tthis && callback) {
                        tthis.isCallSucceed = 1;
                        callback(tthis, result);
                    }
                },
                error: error => {
                    Utils.writeLog(http, baseUrl, error);
                    tthis.isCallSucceed = -1;
                    callback(tthis);
                }
            });
    }

    public static httpPostDialerProperties(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + API_DIGITALSERVICES + "/updatedialerproperties";
        //console.log("before sending request ", body);
        http
            .post<string>(url, body).subscribe((result: string) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.isCallSucceed = -1;
                callback(tthis);
            });
    }
    public static httpGetAllScoreFactorforPopulation(http: HttpClient, baseUrl: string, populationId: number | undefined, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_HEALTHSCORE + "/scoreFactor/" + populationId;
        return http.get<ScoreFactor[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }
    public static httpGetAllScoreFactorFeatures(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_HEALTHSCORE + "/scoreFactor/" + "allfeatures";
        return http.get<Feature[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }
    public static httpDeleteScoreFactor(http: HttpClient, baseUrl: string, scoreFactorId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_HEALTHSCORE + "/scoreFactor/" + scoreFactorId;
        return http.delete<Boolean>(url, {}).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }
    public static httpUpdateScoreFactor(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + API_HEALTHSCORE + "/updateSF";
        //console.log("before sending request ", body);
        http
            .put<string>(url, body).subscribe((result: string) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.isCallSucceed = -1;
                callback(tthis);
            });
    }
    public static httpGetAllCountries(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) { //: Observable<Country[]> {
        const url = baseUrl + API_COUNTRY + "all";
        return http.get<Country[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });

    }

    public static httpPostTriggerAzdf(http: HttpClient, baseUrl: string, body: any, type: string, item: string, tthis: any = undefined, callback: any = undefined, errorCallback: any = undefined) {
        const url = baseUrl + API_AZUREDATAFACTORY + type + "/" + item;
        http.post<any>(url, body).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result, type, item);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
            if (tthis && errorCallback)
                errorCallback(tthis, error);
        }); //console.error(error));
    }

    public static httpGetLastPipelineRunsAzdf(http: HttpClient, baseUrl: string, type: string, item: string, startDate: Date, endDate: Date, tthis: any = undefined, callback: any = undefined, errorCallback: any = undefined) {
        const url = baseUrl + API_AZUREDATAFACTORY + type + "/" + item + "/" + startDate.toISOString() + "/" + endDate.toISOString();
        http.get<any>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
            if (tthis && errorCallback)
                errorCallback(tthis, error);
        }); //console.error(error));
    }

    public static httpGetActivitiesByRunId(http: HttpClient, baseUrl: string, type: string, runId: string, tthis: any = undefined, callback: any = undefined, errorCallback: any = undefined) {
        const url = baseUrl + API_AZUREDATAFACTORY + "activities/" + type + "/" + runId;
        http.get<string[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
            if (tthis && errorCallback)
                errorCallback(tthis, error);
        }); //console.error(error));
    }

    public static httpGetTargetSystemByTenant(http: HttpClient, baseUrl: string, stage: number, tenant: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONFIGURATION + "webservice/" + stage;
        http.get<any>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetWikiByEntity(http: HttpClient, baseUrl: string, stage: number, entity: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CDPWIKI + stage + "/" + entity;
        http.get<any>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpDownloadWsdlByEntity(http: HttpClient, baseUrl: string, stage: number, entity: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + 'cdp/wiki/wsdl/' + stage + "/" + entity;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, entity, "wsdl")
        })
    }

    public static httpDownloadDocByEntity(http: HttpClient, baseUrl: string, stage: number, entity: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + 'cdp/wiki/doc/' + stage + "/" + entity;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, entity, "xlsx")
        })
    }

    public static httpGetTechnicalUsersSetup(http: HttpClient, baseUrl: string, stage: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_SETUP + 'technicaluser';
        http.get<any>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetWebServiceConfigurationList(http: HttpClient, baseUrl: string, stage: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_SETUP + 'webserviceconfigration/' + stage;
        http.get<any>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetCertificates(
        http: HttpClient, baseUrl: string, isSSL: boolean,
        callback: any | undefined = undefined,
        errcallback: any | undefined = undefined
    ) {
        const url = baseUrl + API_SETUP + 'certificate/' + isSSL;
        http.get(url, { responseType: 'blob' })
            .subscribe({
                next: (response: any) => {
                    this.downloadFile(response, "certificates", "zip")
                    this.httpGetZipPassword(http, baseUrl, callback)
                },
                error: () => {
                    if (errcallback)
                        errcallback();
                }
            });
    }

    public static httpGetZipPassword(http: HttpClient, baseUrl: string, callback: any | undefined = undefined) {
        const url = baseUrl + API_SETUP + 'zip-password/';
        http.get<any>(url).subscribe({
            next: result => {
                if (callback)
                    callback(result);
            }, error: error => {
                Utils.writeLog(http, baseUrl, error);
            }
        });
    }

    public static httpGetAllElevators(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ELEVATOR + "all";
        http.get<Elevator[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllEscalators(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ESCALATOR + "all";
        http.get<Escalator[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllOtherAssets(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_OTHERASSET + "all";
        http.get<OtherAsset[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllComponents(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, componentSubSystemID: number, callback: any | undefined = undefined) {
        const url = baseUrl + API_BUSINESS_KEY + "component/" + componentSubSystemID;
        http.get<ComponentItem[]>(url).subscribe(result => {
            if (callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllControllerConfig(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "controllerconfig";
        http.get<ControllerConfig[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllControllerConfigDataType(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "controllerconfigdatatype";
        http.get<ControllerConfigDataType[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllControllerConfigDescription(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "controllerconfigdescription";
        http.get<ControllerConfigDescription[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllControllerConfigPredefinedItemsDescription(http: HttpClient, baseUrl: string, controllerConfigBK: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "controllerconfigpredefineditemsdescriptions/" + controllerConfigBK;
        http.get<any[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllControllerTypeByTenant(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "controllertypebytenant";
        http.get<ControllerTypeByTenant[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    /**
     * return all the controllertype by tenant for countries
     *
     * @param http
     * @param baseUrl
     * @param tthis
     * @param callback
     */
    public static httpGetAllControllerTypeByTenantCountries(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "controllertypebytenant/" + id;
        http.get<ControllerTypeByTenant[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    /**
     * return all the controllertype to connection type
     *
     * @param http
     * @param baseUrl
     * @param tthis
     * @param callback
     */
    public static httpGetAllControllerTypeToConnectionType(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "controllertypetoconnectiontype";
        http.get<ControllerTypeToConnectionType[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    /**
     * return all the controllertype to masterdata required
     *
     * @param http
     * @param baseUrl
     * @param tthis
     * @param callback
     */
    public static httpGetAllControllerTypeToMasterdataRequired(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "controllertypetomasterdatarequired";
        http.get<ControllerTypeToMasterdataRequired[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    /**
     * return all deployment status by controller type
     *
     * @param http
     * @param baseUrl
     * @param tthis
     * @param callback
     */
    public static httpGetAllDeploymentStatusByControllerType(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "controllertypedeploymentstatus";
        http.get<EventArchiveStatus[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetLastBuildIdByInformationType(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, informationType: number, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        const url = baseUrl + API_BUILDRELEASE + "build/" + informationType;
        http.get<BuildRelease>(url).subscribe({
            next: result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error: error => {
                Utils.writeLog(http, baseUrl, error);
                if (tthis && errorCallback)
                    errorCallback(tthis, error);
            }
        });
    }

    public static httpGetReleaseByControllerTypeAndInformationType(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, informationType: number, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        const url = baseUrl + API_BUILDRELEASE + "release/" + informationType;
        http.get<any>(url).subscribe({
            next: result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error: error => {
                Utils.writeLog(http, baseUrl, error);
                if (tthis && errorCallback)
                    errorCallback(tthis, error);
            }
        });
    }

    public static httpCreateBuildByControllerTypeAndInformationType(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, informationType: number, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        const url = baseUrl + API_BUILDRELEASE + informationType;
        http.put<any>(url, {}).subscribe({
            next: result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error: error => {
                Utils.writeLog(http, baseUrl, error);
                if (tthis && errorCallback)
                    errorCallback(tthis, error);
            }
        });
    }

    public static httpReleaseEnvironmentByControllerTypeAndInformationType(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, informationType: number, env: number, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        const url = baseUrl + API_BUILDRELEASE + 'release/' + env + '/' + informationType;
        http.put<any>(url, {}).subscribe({
            next: result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error: error => {
                Utils.writeLog(http, baseUrl, error);
                if (tthis && errorCallback)
                    errorCallback(tthis, error);
            }
        });
    }


    public static waitForDeploymentToStart(httpClient: HttpClient, url: string, callback: (status: 'SUCCESS' | 'ERROR' | 'PROGRESS', message?: string, progress?: number) => void) {
        const intervalPolling = setInterval(() => {
            httpClient.get<string>(url)
                .subscribe({
                    next: (result: any) => {
                        if (result?.description) {
                            console.log('[Deployment Status] ' + result.description);

                            if (result.description.indexOf('OK -') === 0) {
                                clearInterval(intervalPolling);
                                callback('SUCCESS');
                            }
                            else if (/^(ERROR|FAILED)\s-/.test(result.description)) {
                                clearInterval(intervalPolling);
                                callback('ERROR', result.description);
                            }
                            else if (result.description.includes("|/|")) {
                                clearInterval(intervalPolling);
                                const textPart = result.description.split("|/|")[0].trim();
                                const fractionPart = result.description.split("|/|")[1].trim();
                                const [numerator, denominator] = fractionPart.split('/').map(Number);
                                callback('PROGRESS', textPart, numerator / denominator * 100);
                            } else {
                                callback('PROGRESS', result.description);
                            }

                        }
                    },
                    error: error => {
                        clearInterval(intervalPolling);
                        callback('ERROR', error);
                    }
                });
        }, 3000)
    }

    /**
     * return all the controllertypes available to the user's tenant
     * 
     * @param http
     * @param baseUrl
     * @param tthis
     * @param callback
     */
    public static httpGetAllControllerTypes(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "all";
        http.get<ControllerTypeByTenant[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    /**
     * return all the controllertypes available to the user's tenant - Allen
     * 
     * @param http
     * @param baseUrl
     * @param tthis
     * @param tenantid
     * @param callback
     */
    public static httpGetAllControllerTypesByTenant(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, tenantid: string, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "all/" + tenantid;
        http.get<ControllerTypeByTenant[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    /**
     * return all the controllertypes digitalservices available to the user's tenant - Allen
     * 
     * @param http
     * @param baseUrl
     * @param tthis
     * @param tenantid
     * @param callback
     */
    public static httpGetAllControllerTypesByTenantDigitalServices(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, tenantid: string, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "alldigitalservices/" + tenantid;
        http.get<ControllerTypeByTenant[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    /**
     * return all controllertypes available
     * 
     * @param http
     * @param baseUrl
     * @param tthis
     * @param callback
     */
    public static httpGetAllControllerTypesAvailable(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE + "all-controllertype";
        http.get<ControllerType[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    /**
     * return if the current selected tenant and controller type is the controller owner rule.
     * 
     * @param http
     * @param baseUrl
     * @param tthis
     * @param callback
     */
    public static httpGetIsControllerOwner(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, tenant: string, controllerTypeId: number, callback: any | undefined = undefined) {
        const url = baseUrl + API_GENERIC + "controllerowner/" + `${tenant}/${controllerTypeId}`;
        http.get<boolean[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static async httpGetAllErrorCodes(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "all";
        await http.get<ErrorCode[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllTroubleShootingKeywords(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "keywords";
        http.get<string[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpPutErrorCodesAlertRulesToProd(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "alertrulestoprod";
        http
            .put<boolean>(url, {})
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    // Allen: get all error codes ml
    public static async httpGetErrorCodesML(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "errorcodeml";
        await http.get<ErrorCodeML[]>(url).subscribe(result => {
            if (tthis && callback) {
                callback(tthis, result)
            }
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }


    // Allen: get all possible failure ml undo histories
    public static async httpGetPossibleFailureMLUndoHistories(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "possiblefailuremlundohistory";
        await http.get<PossibleFailureMLUndoHistory[]>(url).subscribe(result => {
            if (tthis && callback) {
                callback(tthis, result)
            }
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }

    //public static httpGetAllErrorCodes(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
    //    const url = baseUrl + API_ERROR_CODE + "all";
    //    http.get<ErrorCode[]>(url).subscribe(result => {
    //        if (tthis && callback)
    //            callback(tthis, result);
    //    }, error => {
    //        Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
    //    }); //console.error(error));
    //}

    public static httpGetAllErrorCodesNotMapped(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "notmapped";
        http.get<ErrorCodeNotMapped[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllErrorCodesForControllerType(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "allerrorcodescontrollertype/" + id;
        http.get<ErrorCode[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }


    public static httpGetAllErrorCodeResolutions(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "resolution/" + id;
        http.get<ErrorCodeResolution[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllFPErrorCodeResolutions(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        let url = baseUrl + API_FINGERPRINT + "resolution/" + id;
        http.get<ErrorCodeResolution[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }


    public static httpGetDESDeviceRelationship(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "desdevices/" + id;
        http.get<DESDeviceRelationship[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    // Allen: get PossibleFailureML by ErrorCodeId
    public static httpGetPossbileFailureMLByErrorCodeId(http: HttpClient, baseUrl: string, errorcodeid: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "possiblefailureml/" + errorcodeid;
        http.get<PossibleFailureML[]>(url).subscribe(result => {
            if (tthis && callback) {
                callback(tthis, result)
            }
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }

    public static getPossibleFailureMLAPIUrl(baseUrl: string, errorcodeid: number) {
        return baseUrl + API_ERROR_CODE + "possiblefailureml/" + errorcodeid;
    }

    /**
     *
     * @param http
     * @param baseUrl
     * @param tthis     - [optional] passing this object to use in the callback function
     * @param callback
     */
    public static httpGetAllExceptionLog(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_LOG + "Exceptions";
        http.get<ExceptionLog[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    /**
     * 
     * @param http
     * @param baseUrl
     * @param tthis     - [optional] passing this object to use in the callback function
     * @param callback
     */
    public static httpGetAllLanguages(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined, subfilter: string = '') {
        const url = baseUrl + API_LANGUAGE;

        http.get<Language[]>(url + "all" + subfilter).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error)); 
    }

    public static httpGetAllLocations(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_BUSINESS_KEY + "location";
        http.get<ComponentSubSystem[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllMaintenanceControlPlan(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_CONTROL_PLAN + "all";
        http.get<MaintenanceControlPlan[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllMaintenanceControlPlanGroupActions(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_CONTROL_PLAN + "allgroupactions/" + id;
        http.get<MaintenanceControlPlanGroupAction[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpAllGetMaintenanceControlPlanGroupActionComponents(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_CONTROL_PLAN + "allgroupactioncomponents/" + id;
        http.get<MaintenanceControlPlanGroupActionComponent[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpAllGetMaintenanceControlPlanGroupActionComponentErrors(http: HttpClient, baseUrl: string, id: number, component: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_CONTROL_PLAN + "allgroupactioncomponenterrors/" + id + "/" + component;
        http.get<MaintenanceControlPlanGroupActionComponentError[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpAllGetMaintenanceControlPlanGroupActionComponentProposedErrors(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_CONTROL_PLAN + "allgroupactioncomponentproposederrors/" + id;
        http.get<MaintenanceControlPlanGroupActionComponentProposedErrors[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllMaintenanceControlPlanGroups(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_CONTROL_PLAN + "allgroups/" + id;
        http.get<MaintenanceControlPlanGroup[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllWarnings(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_WARNING + "all";
        http.get<MaintenanceWarning[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllWarningResolutions(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_WARNING + "resolutions/" + id;
        http.get<MaintenanceWarningResolution[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpDownloadMaintenanceWarnings(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/maintenancewarnings/maintenancewarnings";
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, 'MaintenanceWarnings', "xlsx")
        });
    }

    public static httpGetAllFingerprintRulesByTenant(http: HttpClient, baseUrl: string, ids: string[], tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        let httpParams: HttpParams = new HttpParams();
        ids.forEach(id => httpParams = httpParams.append('tenants', id));

        const url = baseUrl + API_FINGERPRINT + "all/";

        http.get<TenantControllerTypeFingerprintRule[]>(url, { params: httpParams }).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

        }); //console.error(error));
    }

    public static httpFPControllerConfiguration(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        let httpParams: HttpParams = new HttpParams();
        //        ids.forEach(id => httpParams = httpParams.append('tenants', id));

        let url = baseUrl + API_FINGERPRINT + "fp-controllerconfiguration/";

        http.get<TenantControllerTypeFingerprintRule[]>(url, { params: httpParams }).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

        }); //console.error(error));
    }

    public static httpFPModesAvailable(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        let httpParams: HttpParams = new HttpParams();
        //        ids.forEach(id => httpParams = httpParams.append('tenants', id));

        let url = baseUrl + API_FINGERPRINT + "fp-modesavailable/";

        http.get<any[]>(url, { params: httpParams }).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

        }); //console.error(error));
    }


    public static httpFPTriggerConditions(http: HttpClient, baseUrl: string, PopulationSetupId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        let httpParams: HttpParams = new HttpParams();
        //        ids.forEach(id => httpParams = httpParams.append('tenants', id));

        let url = baseUrl + API_FINGERPRINT + "fp-triggerconditions/" + PopulationSetupId;

        http.get<any[]>(url, { params: httpParams }).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

        }); //console.error(error));
    }




    public static httpGetBranchHierarchy(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_BRANCHHIERARCHY;

        http.get<BranchHierarchyView[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

        }); //console.error(error));
    }

    public static httpGetBranchHierarchyRef(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_BRANCHHIERARCHY + '/ref';

        http.get<BranchHierarchyRef[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

        }); //console.error(error));
    }

    public static httpGetBranchHierarchyKey(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_BRANCHHIERARCHY + '/key';

        http.get<BranchHierarchyKey[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

        }); //console.error(error));
    }

    public static httpDownloadBranchHierarchy(http: HttpClient, baseUrl: string, stage: number, tenant: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/branchhierarchy";
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenant + '_BranchHierarchy', "xlsx")
        });
    }

    public static httpGetBranchHierarchyKeyByCountry(http: HttpClient, baseUrl: string, country: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_BRANCHHIERARCHY + '/keys/' + country;

        http.get<BranchHierarchyKey[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

        }); //console.error(error));
    }

    public static httpPostBranchHierarchyDeploy(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_BRANCHHIERARCHY + "/deployBranchHiearchyFile";
        http
            .post(url, null)
            .subscribe({
                next: (res) => {
                    if (tthis && callback)
                        callback(tthis, res);
                },
                error: (error) => {
                    if (callbackerror)
                        callbackerror(tthis, error)
                }
            });
    }

    //#region "Inspection"

    public static httpGetInspections(http: HttpClient, baseUrl: string, stage: number, body: InspectionFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "inspections/" + stage;

        http.post<InspectionView[]>(url, body)
            .subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                alert('Error');
                Utils.writeLog(http, baseUrl, error);
                console.error(error);
            });
    }

    public static httpGetinspectionDetails(http: HttpClient, baseUrl: string, stage: number, inspectionId: string, unitId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "inspectionDetails/" + stage + "/" + inspectionId + "/" + unitId;
        http.get<OperationMode[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpUpdateInspections(http: HttpClient, baseUrl: string, stage: number, inspection: any[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "inspections" + "/" + stage;
        http
            .put<InspectionView>(url, inspection)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis, error)

            }); //console.error(error));
    }

    public static httpDownloadInspections(http: HttpClient, baseUrl: string, stage: number, tenantId: string, body: InspectionFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/inspections?stage=" + stage + "&filename=inspections";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_Inspections', "xlsx")
        });
    }

    //#endregion "Inspection"

    public static httpGetAllOperationModes(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_OPERATION_MODE + "all";
        http.get<OperationMode[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllOperationModesHarmonized(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_OPERATION_MODE + "harmonized";
        http.get<HarmonizedOperationMode[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpPutOpModesAlertRulesToProd(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_OPERATION_MODE + "alertrulestoprod";
        http
            .put<boolean>(url, {})
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetAllAlertRules(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ALERTRULE
        http.get<AlertRule[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllResolutions(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_BUSINESS_KEY + "resolution";
        http.get<BusinessKeySon[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllTestAreas(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_TEST_CASE + "areas";
        http.get<TestArea[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllTestCases(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_TEST_CASE + "all/" + false;
        http.get<TestCase[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllTestCasesFilteredByITRelevant(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_TEST_CASE + "all/" + true;
        http.get<TestCase[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllTestCasesDatabricksTrigger(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_TEST_CASE + "databrickstriggers";
        http.get<TestCaseDatabricksTrigger[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllDevices(http: HttpClient, baseUrl: string, filter: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_TEST_CASE + "devices/" + filter;
        http.get<Elevator[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetAllTranslationAreas(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_TRANSLATION_AREA + "all";
        http.get<TranslationArea[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetBusinessKey(http: HttpClient, baseUrl: string, translationCodeID: number, TranslationAreaID: number, LanguageID: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_BUSINESS_KEY + translationCodeID + "/" + TranslationAreaID + "/" + LanguageID;
        http.get<BusinessKey[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetErrorCode(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + id;
        http.get<ErrorCode>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetFileDeploy(http: HttpClient, baseUrl: string, title: string) {
        let api = API_OPERATION_MODE;
        if (title === "Error") api = API_ERROR_CODE;

        const url = baseUrl + api;
        http.get(url);
    }

    //public static httpGetIsUserAdmin(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
    //    const url = baseUrl + API_GENERIC;

    //    http.get<boolean>(url + "isadmin").subscribe(result => {
    //        if (tthis && callback)
    //            callback(tthis, result);
    //    }, error => {
    //        Utils.writeLog(http, baseUrl, error);
    //    });
    //}


    public static httpGetLanguageControllerTypeOperationMode(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_LANGUAGE;

        http.get<Language[]>(url + "operationmode").subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetLanguageControllerTypeErrorCode(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_LANGUAGE;

        http.get<Language[]>(url + "errorcode").subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetMaintenanceControlPlan(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_CONTROL_PLAN + id;
        http.get<MaintenanceControlPlan>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetMaintenanceControlPlanGroupAction(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_CONTROL_PLAN + "groupaction/" + id;
        http.get<MaintenanceControlPlanGroupAction>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetMaintenanceControlPlanGroupActionComponent(http: HttpClient, baseUrl: string, id: number, component: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_CONTROL_PLAN + "groupactioncomponent/" + id + "/" + component;
        http.get<MaintenanceControlPlanGroupActionComponent>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }


    public static httpGetMaintenanceControlPlanGroup(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_MAINTENANCE_CONTROL_PLAN + "group/" + id;
        http.get<MaintenanceControlPlanGroup>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetPossibleFailure(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "possiblefailure/" + id;
        http.get<ErrorCodeResolution>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpTranslatePossibleFailure(http: HttpClient, baseUrl: string, data: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_ERROR_CODE + "translatepossiblefailure";
        http.post<any>(url, data).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetOperationMode(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_OPERATION_MODE + id;

        http.get<OperationMode>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetSelectedControllerType(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTROLLER_TYPE;
        http.get<ControllerType>(url + "selected").subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
            //this.controllertype = result;
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error)
        }); //console.error(error));
    }

    // Allen for Claims
    public static httpGetClaims(http: HttpClient, baseUrl: string, tthis: any, callback: Function) {
        const url = baseUrl + API_CLAIMS;
        http.get<Claims>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }

    public static httpGetSelectedTenant(http: HttpClient, baseUrl: string, tthis: any, callback: Function) {
        const url = baseUrl + API_TENANT;
        http.get<string>(url + "selected").subscribe(result => {
            if (tthis && callback) {
                callback(tthis, result);
            }
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }

    /**
     * 
     * @param http
     * @param baseUrl
     * @param tthis     - [optional] passing this object to use in the callback function
     * @param callback
     */
    public static httpGetSelectedLanguage(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_LANGUAGE;
        http.get<Language>(url + "selected").subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
            //this.language = result;
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetTestCase(http: HttpClient, baseUrl: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_TEST_CASE + id;
        http.get<TestCase>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetTestCaseBatched(http: HttpClient, baseUrl: string, testcaseid: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_TEST_CASE + "batched/" + testcaseid;
        http.get<TestCaseBatched[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetTestCaseMessageTypeSchemaKeyDescription(http: HttpClient, baseUrl: string, testcaseid: number, messagetypeid: number, index: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_TEST_CASE + "message/" + testcaseid + "/" + messagetypeid + "/" + index;
        http.get<TestCaseMessageTypesSchemaKeysDescription>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetTestCaseMessageTypeSchemaKeyDescriptions(http: HttpClient, baseUrl: string, testcaseid: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_TEST_CASE + "message/" + testcaseid;
        http.get<TestCaseMessageTypesSchemaKeysDescription[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetTestCaseMessageTypeSchemaKeyValues(http: HttpClient, baseUrl: string, testcaseid: number, messagetypeid: number, indexintestcase: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_TEST_CASE + "messagevalues/" + testcaseid + "/" + messagetypeid + "/" + indexintestcase;
        http.get<TestCaseMessageTypesSchemaKeys[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }

    public static httpGetUserTenant(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_COUNTRY + "usertenant";
        http.get<Country>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }

    public static httpGetContracts(http: HttpClient, baseUrl: string, stage: number, body: ContractFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "contracts/" + stage;
        tthis.subscriptions.push(http
            .post<Contract[]>(url, body)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            })); //console.error(error));
    }

    public static httpGetContactToUnit(http: HttpClient, baseUrl: string, stage: number, body: ContactToUnitFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "contacttounit/" + stage;
        tthis.subscriptions.push(http
            .post<Contract[]>(url, body)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            })); //console.error(error));
    }

    public static httpDownloadContracts(http: HttpClient, baseUrl: string, stage: number, tenantId: string, body: ContractFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/contracts?stage=" + stage + "&filename=contracts";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_Contracts', "xlsx")
        });
    }

    public static httpGetDetailedContract(http: HttpClient, baseUrl: string, stage: number, contract: Contract, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "contract-info";
        const payload: ContractInfoRequest = {
            stage: stage,
            contractNumber: this.encodeSlashes(contract.ContractNumber),
            unitId: this.encodeSlashes(contract.UnitId),
            contractLine: contract.ContractLine || 'null',
            contractType: contract.ContractType
        };

        http
            .post<Contract>(url, payload).subscribe({
                next: (res) => {
                    if (tthis && callback)
                        callback(tthis, res);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                }
            });
    }

    public static httpUpdateContracts(http: HttpClient, baseUrl: string, stage: number, contracts: Contract[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "contracts" + "/" + stage;
        http
            .put<Contract>(url, contracts)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis, error)

            }); //console.error(error));
    }

    public static httpGetContractFacilityManagers(http: HttpClient, baseUrl: string, stage: number, body: FacilityManagerFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "contractsfacilitymanager/" + stage;
        tthis.subscriptions.push(
            http
                .post<FacilityManager[]>(url, body)
                .subscribe(res => {
                    if (tthis && callback)
                        callback(tthis, res);
                }, error => {
                    if (callbackerror)
                        callbackerror(tthis, error)

                })); //console.error(error));
    }

    public static httpDownloadContractFacilityManager(http: HttpClient, baseUrl: string, stage: number, tenantId: string, body: FacilityManagerFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/contractsfacilitymanager?stage=" + stage + "&filename=contractsfacilitymanager";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_ContractFacilityManagers', "xlsx")
        });
    }

    public static httpGetDetailedContractFacilityManager(http: HttpClient, baseUrl: string, stage: number, facilityManager: FacilityManager, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "contractfacilitymanager-info" + "/" + stage + "/" + facilityManager.FacilityManagerId + "/" + facilityManager.ContractNumber;
        http
            .get<FacilityManagerDetails>(url).subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpUpdateContractFacilityManagers(http: HttpClient, baseUrl: string, stage: number, facilityManagers: FacilityManager[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "contractsfacilitymanager" + "/" + stage;
        http
            .put<FacilityManager>(url, facilityManagers)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis, error)

            }); //console.error(error));
    }

    public static httpGetContractBundleInformation(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTRACTBUNDLE + "configuration";
        tthis.subscriptions.push(
            http
                .get<ContractBundle[]>(url)
                .subscribe(res => {
                    if (tthis && callback)
                        callback(tthis, res);
                }, error => {
                    Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

                })); //console.error(error));
    }

    public static httpGetContractBundleOptions(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTRACTBUNDLE + "options";
        tthis.subscriptions.push(
            http
                .get<ContractBundle[]>(url)
                .subscribe(res => {
                    if (tthis && callback)
                        callback(tthis, res);
                }, error => {
                    Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

                })); //console.error(error));
    }

    public static httpAddContractBundleByTenant(http: HttpClient, baseUrl: string, bundleId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTRACTBUNDLE + bundleId;
        http
            .post<any>(url, {})
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpAddAllContractBundleByTenant(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTRACTBUNDLE + 'all';
        http
            .post<any>(url, {})
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpDeleteContractBundleByTenant(http: HttpClient, baseUrl: string, bundleId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_CONTRACTBUNDLE + bundleId;
        http
            .delete<any>(url, {})
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpPostAuditChangeLog(http: HttpClient, baseUrl: string, entity: string,row: any,tthis: any,callback: (logs: any[]) => void) {
        const url = baseUrl + API_AUDIT + "changelog";
        http.post(url, { entity, row }, { withCredentials: true })
        .subscribe(response => {
            const logs = Array.isArray(response)
                ? response
                : (response && typeof response === 'object' && 'entries' in response && Array.isArray((response as any).entries)
                    ? (response as any).entries
                    : []);
            if (callback) callback.call(tthis, logs);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }

    public static httpGetCustomerFacilityManagers(http: HttpClient, baseUrl: string, stage: number, body: CustomerFacilityManagerFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "customersfacilitymanager/" + stage;
        tthis.subscriptions.push(http
            .post<CustomerFacilityManager[]>(url, body)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            })); //console.error(error));
    }

    public static httpDownloadCustomerFacilityManager(http: HttpClient, baseUrl: string, stage: number, tenantId: string, body: CustomerFacilityManagerFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/customersfacilitymanager?stage=" + stage + "&filename=customersfacilitymanager";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_CustomerFacilityManagers', "xlsx")
        });
    }

    public static httpUpdateCustomerFacilityManagers(http: HttpClient, baseUrl: string, stage: number, facilityManagers: CustomerFacilityManager[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "customersfacilitymanager" + "/" + stage;
        http
            .put<FacilityManager>(url, facilityManagers)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis, error)

            }); //console.error(error));
    }

    public static httpGetCustomers(http: HttpClient, baseUrl: string, stage: number, body: CustomerFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {

        const url = baseUrl + Utils.getInfoHubAPI() + "customers" + "/" + stage;
        tthis.subscriptions.push(http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis, error)

            })); //console.error(error));
    }

    public static httpGetDetailedCustomer(http: HttpClient, baseUrl: string, stage: number, customer: Customer, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "customer-info" + "/" + stage + "/" + customer.CustomerId + "/" + encodeURIComponent(customer.CustomerName);
        http
            .get<Customer>(url).subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpUpdateCustomers(http: HttpClient, baseUrl: string, stage: number, customers: any[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "customers" + "/" + stage;
        http
            .put<Customer>(url, customers)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis, error)

            }); //console.error(error));
    }

    public static httpDownloadCustomers(http: HttpClient, baseUrl: string, stage: number, tenantId: string, body: CustomerFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/customers?stage=" + stage + "&filename=customers";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_Customers', "xlsx")
        });
    }

    public static httpGetDetailedServiceTicket(http: HttpClient, baseUrl: string, stage: number, serviceTicket: ServiceTicket, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "servicetickets" + "/" + stage + "/" + encodeURIComponent(this.encodeSlashes(serviceTicket.UnitId)) + "?ticketId=" + serviceTicket.TicketId + "&serviceRecordId=" + serviceTicket.ServiceRecordId + "&transactionId=" + serviceTicket.TransactionId
        http
            .get<ServiceTicket>(url).subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetServiceTickets(http: HttpClient, baseUrl: string, stage: number, body: ServiceTicketFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "servicetickets" + "/" + stage;
        tthis.subscriptions.push(http
            .post<ServiceTicket[]>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            })); //console.error(error));
    }

    public static httpUpdateServiceTickets(http: HttpClient, baseUrl: string, stage: number, servicetickets: any[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "servicetickets" + "/" + stage;
        http
            .put<ServiceTicket>(url, servicetickets)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis, error)

            }); //console.error(error));
    }

    public static httpDownloadServiceTickets(http: HttpClient, baseUrl: string, stage: number, tenantId: string, body: ServiceTicketFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/servicetickets?stage=" + stage + "&filename=servicetickets";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_ServiceTickets', "xlsx")
        });
    }

    public static httpGetContacts(http: HttpClient, baseUrl: string, body: ContactsFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "contacts";
        http
            .post<ContactInfoHub>(url, body)
            .subscribe({
                next: (res) => {
                    if (tthis && callback)
                        callback(tthis, res);
                },
                error: (error) => {
                    if (callbackerror)
                        callbackerror(tthis, error)
                }
            }); //console.error(error));
    }

    public static httpUpdateContacts(http: HttpClient, baseUrl: string, body: ContactInfoHub[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "updatecontacts";
        http
            .post<ContactInfoHub>(url, body)
            .subscribe({
                next: (res) => {
                    if (tthis && callback)
                        callback(tthis, res);
                },
                error: (error) => {
                    if (callbackerror)
                        callbackerror(tthis, error)
                }
            }); //console.error(error));
    }

    public static httpDownloadContacts(http: HttpClient, baseUrl: string, tenantId: string, body: ContactsFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/contacts?filename=Contacts";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_Contacts', "xlsx")
        });
    }

    public static httpGetElevators(http: HttpClient, baseUrl: string, stage: number, body: ElevatorFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getEventArchiveAPI() + "elevators" + "/" + stage;
        tthis.subscriptions.push(http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            })); //console.error(error));
    }

    public static httpGetDetailedElevator(http: HttpClient, baseUrl: string, stage: number, elevator: Elevator, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEventArchiveAPI() + "elevator-info" + "/" + stage + "/" + encodeURIComponent(this.encodeSlashes(elevator.UnitID));
        http
            .get<ElevatorDetails>(url).subscribe((res: ElevatorDetails) => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpUpdateElevators(http: HttpClient, baseUrl: string, elevators: any[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_EVENTARCHIVE + "elevators";
        http
            .put<Elevator>(url, elevators)
            .subscribe(() => {
                if (tthis && callback)
                    callback(tthis);
            }, error => {
                var errorMessage = '';
                if (error.status === 412) {
                    errorMessage = "Incorrect Branch Number. Please, indicate a proper branch for selected country checking Branch Hierarchy section.";
                } else if (error.status === 509) {
                    errorMessage = "There was an inernal server error calling to Push API. Please, contact with admins";
                }

                if (callbackerror)
                    callbackerror(tthis, errorMessage)

            }); //console.error(error));


    }

    public static httpGetEscalators(http: HttpClient, baseUrl: string, stage: number, body: EscalatorFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getEventArchiveAPI() + "escalators" + "/" + stage;
        tthis.subscriptions.push(http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            })); //console.error(error));
    }

    public static httpGetDetailedEscalator(http: HttpClient, baseUrl: string, stage: number, escalator: Escalator, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEventArchiveAPI() + "escalator-info" + "/" + stage + "/" + encodeURIComponent(this.encodeSlashes(escalator.UnitID));
        http
            .get<any>(url).subscribe((res: any) => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpUpdateEscalators(http: HttpClient, baseUrl: string, stage: number, escalators: any[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_EVENTARCHIVE + "escalators";
        http
            .put<Escalator>(url, escalators)
            .subscribe(() => {
                if (tthis && callback)
                    callback(tthis);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis)

            }); //console.error(error));
    }

    public static httpDownloadEscalators(http: HttpClient, baseUrl: string, tenantId: string, body: EscalatorFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/escalators?filename=escalators";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_Escalators', "xlsx")
        });
    }

    public static httpGetOtherAssets(http: HttpClient, baseUrl: string, stage: number, body: OtherAssetFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getEventArchiveAPI() + "otherassets" + "/" + stage;
        tthis.subscriptions.push(http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            })); //console.error(error));
    }

    public static httpGetDetailedOtherAsset(http: HttpClient, baseUrl: string, stage: number, otherasset: OtherAsset, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEventArchiveAPI() + "otherasset-info" + "/" + stage + "/" + encodeURIComponent(this.encodeSlashes(otherasset.UnitID));
        http
            .get<any>(url).subscribe((res: any) => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetOtherAssetAttributes(http: HttpClient, baseUrl: string, stage: number, otherasset: OtherAsset, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEventArchiveAPI() + "otherasset-attr" + "/" + stage + "/" + encodeURIComponent(this.encodeSlashes(otherasset.UnitID));
        http
            .get<any>(url).subscribe((res: any) => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpUpdateOtherAssets(http: HttpClient, baseUrl: string, stage: number, otherassets: any[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_EVENTARCHIVE + "otherasset" + "/" + stage;
        http
            .put<OtherAsset>(url, otherassets)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis)
            }); //console.error(error));
    }

    public static httpUpdateOtherAssetAttrs(http: HttpClient, baseUrl: string, stage: number, otherassetsattrs: any[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_EVENTARCHIVE + "otherassetattrs" + "/" + stage;
        http
            .put<OtherAsset>(url, otherassetsattrs)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis, error)

            }); //console.error(error));
    }

    public static httpDownloadOtherAssets(http: HttpClient, baseUrl: string, tenantId: string, body: OtherAssetFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/otherassets?filename=otherassets";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_OtherAssets', "xlsx")
        });
    }

    public static httpGetKpiUnits(http: HttpClient, baseUrl: string, stage: number, body: KpiFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getInfoHubAPI() + "kpiunits" + "/" + stage;
        http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetKpis(http: HttpClient, baseUrl: string, stage: number, body: KpiUnit, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "kpis" + "/" + stage + "/" + body.UnitId + "/" + body.ContractNumber + "/" + body.CustomerId;
        http
            .get<any>(url).subscribe((res: any) => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpUpdateKpis(http: HttpClient, baseUrl: string, stage: number, items: any[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "kpis" + "/" + stage;
        http
            .put<OtherAsset>(url, items)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis, error)

            }); //console.error(error));
    }

    public static httpUpdateContactToUnit(http: HttpClient, baseUrl: string, stage: number, items: any[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "contacttounit" + "/" + stage;
        http
            .put<any>(url, items)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis, error)

            }); //console.error(error));
    }

    public static httpDownloadKpis(http: HttpClient, baseUrl: string, stage: number, tenantId: string, body: KpiFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/kpis?stage=" + stage + "&filename=kpis";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_Kpis', "xlsx")
        });
    }

    public static httpDownloadContactToUnit(http: HttpClient, baseUrl: string, stage: number, tenantId: string, body: ContactToUnitFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/contacttounit?stage=" + stage + "&filename=contacttounit";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_ContactToUnit', "xlsx")
        });
    }

    public static httpGetChairlifts(http: HttpClient, baseUrl: string, stage: number, body: ChairliftFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getEventArchiveAPI() + "chairlifts" + "/" + stage;
        tthis.subscriptions.push(http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            })); //console.error(error));
    }

    public static httpGetDetailedChairlift(http: HttpClient, baseUrl: string, stage: number, chairlift: Chairlift, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEventArchiveAPI() + "chairlift-info" + "/" + stage + "/" + encodeURIComponent(this.encodeSlashes(chairlift.UnitId));
        http
            .get<ChairliftDetails>(url).subscribe((res: ChairliftDetails) => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpUpdateChairlifts(http: HttpClient, baseUrl: string, stage: number, chairlifts: any[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_EVENTARCHIVE + "chairlifts" + "/" + stage;
        http
            .put<Chairlift>(url, chairlifts)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackerror)
                    callbackerror(tthis, error)

            }); //console.error(error));
    }

    public static httpDownloadChairlifts(http: HttpClient, baseUrl: string, stage: number, tenantId: string, body: ChairliftFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/chairlifts?stage=" + stage + "&filename=chairlifts";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_chairlifts', "xlsx")
        });
    }

    public static httpGetCommands(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "commands";
        http
            .get<any>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetAllowedRemoteActions(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "allowedactions";
        http
            .get<any>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetCommandConfigControllerType(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "commandconfigcontrollertype";
        http
            .get<any>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetCommandConfigTemplate(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "commandconfigtemplate";
        http
            .get<any>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetAssetParameters(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "assetparameter";
        http
            .get<any>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetParameterKeywords(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "parameterkeywords";
        http
            .get<any>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetParameterConfigController(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "parametersconfigcontroller";
        http
            .get<any>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpUpdateParameterConfigController(http: HttpClient, baseUrl: string, body: ParameterConfigController, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "parametersconfig";
        http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetFunctionConfig(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "functionconfig";
        http
            .get<any>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetFunctionConfigParameters(http: HttpClient, baseUrl: string, functionKey: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "functionconfigparams/" + functionKey;
        http
            .get<any>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpCreateParameterConfig(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "parameter";
        http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpUpdateFunctionConfigParameter(http: HttpClient, baseUrl: string, body: FunctionConfigParameter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "functionconfigparams";
        http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpCreateFunctionConfig(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "functionconfig";
        http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetAutoRemoteResetCommandConfig(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined, stage: number = 1) {
        const url = baseUrl + Utils.getRemoteActionAPI() + `autoremoteresetcommandconfig?stage=${stage}`;
        http
            .get<AutoRemoteResetCommandConfig>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                alert("Error getting auto remote reset command config, please try again later.");
                //Utils.writeLog(http, baseUrl, error);
            });
    }

    public static httpAutoRemoteResetCommandConfig(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getRemoteActionAPI() + "autoremoteresetcommandconfig";
        http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                alert("Error updating auto remote reset command config, please try again later.");
                //Utils.writeLog(http, baseUrl, error);
            });
    }



    public static httpGetRemoteResetCommandConfig(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "remoteresetcommandconfig";
        http
            .get<any>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetRemoteResetSupported(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getRemoteActionAPI() + "isremoteresetsupported";
        http
            .get<any>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetAvailableMacAddress(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getVirtualProvisioningAPI() + "/registry";
        tthis.subscriptions.push(http
            .get<string>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            })
        )
    }

    public static httpGetControllerTypes(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getVirtualProvisioningAPI() + "/controllertypes";
        tthis.subscriptions.push(http
            .get<string>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }))
    }

    public static httpGetUnitIdsToDeviceMapping(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getVirtualProvisioningAPI() + "/unittodevicemapping";
        tthis.subscriptions.push(http
            .get<UnitIdToDeviceMapping>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            })
        )
    }

    public static httpGetUnprovisionedAssetByUnitId(http: HttpClient, baseUrl: string, unitId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getVirtualProvisioningAPI() + "/unprovisionedassetbyunitid/" + unitId;
        http
            .get(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetIsManyToOneProvisioning(http: HttpClient, baseUrl: string, macAddress: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getVirtualProvisioningAPI() + "/isManyToOneProvisioning/" + macAddress;
        tthis.subscriptions.push(http
            .get<boolean>(url).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            })
        )
    }

    public static httpCreateProvisioningRequest(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getVirtualProvisioningAPI() + "/provision";
        http
            .post<any>(url, body).subscribe(() => {
                if (tthis && callback)
                    callback(tthis);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpPreRegisterBluebox(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getVirtualProvisioningAPI() + "/PreRegisterBlueBox";
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetGroupFunctionByCurrentManagementId(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getGroupFunctionAPI();
        http
            .get<string>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpGetSelectedGroupFunction(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getGroupFunctionAPI();
        http.get<string>(url + "/selected").subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
            //this.language = result;
        }, error => {
            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);
        }); //console.error(error));
    }
    public static httpGetKPIDefinitionRef(http: HttpClient, baseUrl: string, tthis: any = undefined, callback: any = undefined, callbackError: any = undefined)
    {
        const url = baseUrl + Utils.getKpiManagementAPI() + "/kpi_definition_reference/all";
        http.get<any[]>(url).subscribe({
            next: (r: any) => {
                if (tthis && callback)
                    callback(tthis, r);
            },
            error: (error) => {
                Utils.writeLog(http, baseUrl, error);
            }
        });
    }

    public static httpGetActualReportingInformation(http: HttpClient, baseUrl: string, isBranchReporting: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = baseUrl + Utils.getKpiManagementAPI() + '/kpi_all/' + isBranchReporting;
        tthis.subscriptions.push(http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })); //console.error(error));
    }

    public static httpGetOPLYearlyReportingInformation(http: HttpClient, baseUrl: string, isBranchReporting: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = baseUrl + Utils.getKpiManagementAPI() + '/kpi_opl_yearly/' + isBranchReporting;
        tthis.subscriptions.push(http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })); //console.error(error));
    }

    //public static httpUpdateKpiApprovalStatus(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

    //    const url = baseUrl + Utils.getKpiManagementAPI() + "/approvalStatus";
    //    http
    //        .put<any>(url, body).subscribe((result) => {
    //            if (tthis && callback)
    //                callback(tthis, result);
    //        }, error => {
    //            Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

    //        }); //console.error(error));
    //}
    public static httpPostTemplate(url: string, http: HttpClient, baseUrl: string, body: any, tthis: any = undefined, callback: any = undefined, callbackError: any = undefined) {
        http
            .post<any>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    callbackError(tthis, error);
                }
            });
    }

    public static httpReleaseKpiDefinitions(http: HttpClient, baseUrl: string, body: any, scope: KpiApprovalScope, tthis?: any, callback?: any, callbackError?: any) {

        const url = baseUrl + Utils.getKpiManagementAPI() + '/release/' + scope.isActual + '/' + scope.oplyearly + '/' + scope.isBranchReporting;
        http
            .put<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLogOrCallbackError(http, baseUrl, error, tthis, callbackError);
            }); //console.error(error));
    }

    public static httpRevokeKpiValues(http: HttpClient, baseUrl: string, body: any, scope: KpiApprovalScope, tthis?: any, callback?: any, callbackError?: any) {

        const url = baseUrl + Utils.getKpiManagementAPI() + '/revoke/' + scope.isActual + '/' + scope.oplyearly + '/' + scope.isBranchReporting;
        http
            .put<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLogOrCallbackError(http, baseUrl, error, tthis, callbackError);
            }); //console.error(error));
    }

    public static httpReleaseKpiNexusValues(http: HttpClient, baseUrl: string, body: any, isBranchReporting: boolean, tthis?: any, callback?: any, callbackError?: any) {
        const url = baseUrl + Utils.getKpiManagementAPI() + '/nexus/release/' + isBranchReporting;
        http
            .put<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLogOrCallbackError(http, baseUrl, error, tthis, callbackError);
            });
    }

    public static httpRevokeKpiNexusValues(http: HttpClient, baseUrl: string, body: any, isBranchReporting: boolean, tthis?: any, callback?: any, callbackError?: any) {
        const url = baseUrl + Utils.getKpiManagementAPI() + '/nexus/revoke/' + isBranchReporting;
        http
            .put<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLogOrCallbackError(http, baseUrl, error, tthis, callbackError);
            });
    }

    public static httpDownloadActualReportingInformation(http: HttpClient, baseUrl: string, file_name: string, showAll: boolean, isBranchReporting: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/actualreportinginformation/" + showAll + "/" + isBranchReporting;
        http.get(url, { responseType: 'blob' }).subscribe(
            (response: any) => { this.downloadFile(response, file_name, "xlsx"); },
            (error: any) => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            });
    }

    public static httpDownloadYearlyOPLInformation(http: HttpClient, baseUrl: string, file_name: string, showAll: boolean, isBranchReporting: boolean, tthis: any | undefined = undefined, callbackError: any | undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/yearlyoplinformation/" + showAll + "/" + isBranchReporting;
        http.get(url, { responseType: 'blob' }).subscribe(
            (response: any) => { this.downloadFile(response, file_name, "xlsx"); },
            (error: any) => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            });
    }

    public static httpDownloadMonthlyOPLInformation(http: HttpClient, baseUrl: string, file_name: string, showAll: boolean, isBranchReporting: boolean, isActualReportingCall: boolean, tthis: any | undefined = undefined, callbackError: any | undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/monthlyoplinformation/" + showAll + "/" + isBranchReporting + "/" + isActualReportingCall;
        http.get(url, { responseType: 'blob' }).subscribe(
            (response: any) => { this.downloadFile(response, file_name, "xlsx"); },
            (error: any) => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            });
    }

    public static httpGetSectionSchedulerInformation(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getKpiManagementAPI() + "/schedulersection";
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpUpdateSectionSchedulerInformation(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getKpiManagementAPI() + "/schedulersection";
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    //NiOps Requests
    public static httpDownloadNiOpsInformation(http: HttpClient, baseUrl: string, filename: string, tthis: any | undefined = undefined, callBackError: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/niopsreporting";
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, filename, "xlsx"),
                (error: any) => {
                    Utils.writeLog(http, baseUrl, error);
                    callBackError(tthis, error);
                }
        });
    }

    public static httpGetNiOpsUserHistory(http: HttpClient, baseUrl: string, filename: string, tthis: any | undefined = undefined, callBackError: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/niopsuserhistory";
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, filename, "xlsx"),
                (error: any) => {
                    Utils.writeLog(http, baseUrl, error);
                    callBackError(tthis, error);
                }
        });
    }

    ////////////////
    // UMP requests
    public static httpGetUsersByFilter(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined, isDataAnalytStage = false, errorCallback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/filter/" + Utils.getDomainByWindowLocation() + "/" + isDataAnalytStage;
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback) {
                    callback(tthis, result);
                }

            }, error => {
                console.log("that is the error", error)
                Utils.writeLog(http, baseUrl, error);
                if (tthis && errorCallback) {
                    errorCallback(tthis, error);
                }

            });
    }
    public static httpGetUsersGroupListByFilter(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined, isDataAnalytStage: boolean = false) {

        const url = baseUrl + Utils.getUMPUser() + "/groupfilterlist/" + Utils.getDomainByWindowLocation() + "/" + isDataAnalytStage;
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback) {
                    callback(tthis, result);
                }

            }, error => {
                Utils.writeLog(http, baseUrl, error);

            });
    }
    public static httpPostGroupModifyUser(http: HttpClient, baseUrl: string, isAdding: boolean, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/groupModifyUser/" + isAdding;
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback) {
                    callback(tthis, result);

                }

            }, error => {
                console.log("that is the error", error)
                Utils.writeLog(http, baseUrl, error);

            });
    }

    public static httpGetInitialFilters(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/initialFilters";
        http.get(url).subscribe((result) => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);

        });
    }

    public static httpGetCreateUserPopupInformation(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/createUserPopupInformation";
        http.get(url).subscribe((result) => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);

        });
    }

    public static httpCreateUser(http: HttpClient, baseUrl: string, body: any, isInternal: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/create/" + Utils.getDomainByWindowLocation() + '/' + isInternal;
        http
            .post<string>(url, body).subscribe((result: string) => {
                if (tthis) tthis.errorMessage = '';
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                if (tthis) tthis.errorMessage = Utils.extractErrorMessage(error);
                callback(tthis, '');
            });
    }

    public static httpUpdateUser(http: HttpClient, baseUrl: string, body: any, userId: string, umpCategory: UMPCategory, umpAction: UMPAction, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        body.umpaction = umpAction;
        body.umpcategory = umpCategory;
        const url = baseUrl + Utils.getUMPUser() + "/user/" + Utils.getDomainByWindowLocation() + '/' + userId;
        http
            .put<string>(url, body).subscribe((result: string) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    tthis.errorMessage = '';
                    callback(tthis);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.isCallSucceed = -1;
                tthis.errorMessage = Utils.extractErrorMessage(error);
                callback(tthis);
            });
    }
    public static httpDeleteUser(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/user/" + userId + "/delete/";
        http

            .delete<string>(url).subscribe({
                next: data => {
                    tthis.isCallSucceed = 1;
                    callback(tthis);

                },
                error: error => {
                    tthis.isCallSucceed = -1;
                    const errorMessage = error.message;
                    console.error('There was an error!', error);
                    callback(tthis);

                }
            });

    }


    public static httpCreateBulkExternalUsers(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/createBulkExternalUsers/" + Utils.getDomainByWindowLocation();
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callback(tthis, false);

            });
    }

    public static httpGetBulkUserExcelTemplate(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/bulkexceltemplate";
        http
            .get(url, { responseType: 'blob' }).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callback(tthis, false);
            });
    }

    public static httpGetUserDetails(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined, isDataAnalytStage: boolean = false) {
        const url = baseUrl + Utils.getUMPUser() + "/details/" + userId + '/' + isDataAnalytStage;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);

            });
    }

    public static httpGetUserLicenses(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/licenses/" + userId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.License_Response_State = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.License_Response_State = -1;
                Utils.writeLog(http, baseUrl, error);

            });
    }

    public static httpGetDirIndirUserRoles(http: HttpClient, baseUrl: string, componentName: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/dirIndirUserRoles" + "/" + componentName + "/" + userId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
                tthis.Response_State = -1;
            });
    }
    public static httpGetAllRelatedRoles(http: HttpClient, baseUrl: string, componentName: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getUMPUser() + "/allrelatedroles/" + componentName;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
                tthis.Response_State = -1;
            });
    }

    public static httpGetAllMaxRoles(http: HttpClient, baseUrl: string, componentName: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/" + componentName;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
                tthis.Response_State = -1;
            });
    }

    public static httpGetDirIndirRemainingRoles(http: HttpClient, baseUrl: string, componentName: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/remainingroles" + "/" + componentName + "/" + userId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
                tthis.Response_State = -1;
            });
    }

    public static httpGetUserMersyRoles(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/mersypersonae/" + userId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
                tthis.Response_State = -1;

            });
    }
    public static httpGetSpecialPermissions(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/specialPermissions/" + userId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
                tthis.Response_State = -1;

            });
    }
    public static httpGetMersyRoles(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/mersypersonae";
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
                tthis.Response_State = -1;

            });
    }

    public static httpGetUserMersyGroups(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/usermersygroupfunction/" + userId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
                tthis.Response_State = -1;

            });
    }
    public static httpGetMersyGroups(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/mersygroupfunction";
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
                tthis.Response_State = -1;

            });
    }

    public static httpGetUserAzDevProj(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/adoGroups/" + userId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
                tthis.Response_State = -1;


            });
    }
    public static httpGetAzDevProj(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/adoGroups";
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
                tthis.Response_State = -1;


            });
    }

    public static httpPostGroupsByType(http: HttpClient, baseUrl: string, body: any, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/groups-nottree/" + userId;
        //console.log("before sending request ", body);
        http
            .post<string>(url, body).subscribe((result: string) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.isCallSucceed = -1;
                callback(tthis);
            });
    }

    public static httpRevokeGroupPersonae(http: HttpClient, baseUrl: string, body: any, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/user/" + userId + "/RevokeGroupPersonae";
        http

            .post<string>(url, body).subscribe({
                next: data => {
                    tthis.isCallSucceed = 1;
                    callback(tthis);

                },
                error: error => {
                    tthis.isCallSucceed = -1;
                    const errorMessage = error.message;
                    console.error('There was an error!', error);
                    callback(tthis);

                }
            });

    }
    public static httpGetInlineWiki(http: HttpClient, baseUrl: string, clusterComponentLink: string, title: string | null = null, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getWiki() + "/getInlineWiki/" + clusterComponentLink + '/' + title;
        tthis.subscriptions.push(http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                tthis.spinnerOverlayService.setFalseskipInterceptor();
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
            }));

    }
    public static httpIsWikiAvailable(http: HttpClient, baseUrl: string, clusterComponentLink: string, title: string | null = null, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getWiki() + "/isAvailable/" + clusterComponentLink + '/' + title;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                tthis.spinnerOverlayService.setFalseskipInterceptor();
                Utils.writeLog(http, baseUrl, error);
                tthis.errorResponse = error.message;
            });

    }

    public static httpPostTreeGroupsByType(http: HttpClient, baseUrl: string, body: TreeManagement<UMPCategory>, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/groups/" + userId;
        //console.log("before sending request ", body);
        http
            .post<string>(url, body).subscribe((result: string) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.isCallSucceed = -1;
                callback(tthis);
            });
    }
    public static httpPostChangePassword(http: HttpClient, baseUrl: string, body: any, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/resetPassword/" + userId;
        http
            .post<string>(url, body).subscribe((result: string) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.isCallSucceed = -1;
                callback(tthis);
            });
    }
    public static httpResentInvitation(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {


        const url = baseUrl + Utils.getUMPUser() + "/SendUserInvitation/" + Utils.getDomainByWindowLocation();
        http
            .post<string>(url, body).subscribe((result: string) => {
                if (tthis && callback) {
                    tthis.isCallSucceedResInv = 1;
                    callback(tthis);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.isCallSucceedResInv = -1;
                callback(tthis);
            });
    }



    public static httpGetUserDataAnlytics(http: HttpClient, baseUrl: string, userId: string, forceReload: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/dataAnalytics/" + userId + "/?forceReload=" + forceReload;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.Tree_Response_State = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.Tree_Response_State = -1;
                Utils.writeLog(http, baseUrl, error);


            });
    }

    // Async version that returns a Promise for retry mechanism
    public static httpGetUserDataAnlyticsAsync(
        http: HttpClient, 
        baseUrl: string, 
        userId: string, 
        forceReload: boolean
    ): Promise<any> {
        const url = baseUrl + Utils.getUMPUser() + "/dataAnalytics/" + userId + "/?forceReload=" + forceReload;
        
        return new Promise((resolve, reject) => {
            http.get(url).subscribe(
                (result) => {
                    resolve(result);
                },
                (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    reject(error);
                }
            );
        });
    }

    public static httpGetDataAnlytics(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/DataAnalyticsPersonaeByUpn";
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.Tree_Response_State = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.Tree_Response_State = -1;
                Utils.writeLog(http, baseUrl, error);


            });
    }

    public static httpGetUserBranches(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/branches/" + userId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.Tree_Response_State = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.Tree_Response_State = - 1;
                Utils.writeLog(http, baseUrl, error);

            });
    }
    public static httpGetBranches(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/branches";
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.Tree_Response_State = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.Tree_Response_State = - 1;
                Utils.writeLog(http, baseUrl, error);

            });
    }

    public static httpGetUserMersyKPIGroupFunction(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getMersyKPIGroupFunction() + "/mersyKpiGroupFunctionGroups/" + userId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.Tree_Response_State = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.Tree_Response_State = - 1;
                Utils.writeLog(http, baseUrl, error);

            });
    }

    public static httpGetMersyKPIGroupFunction(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getMersyKPIGroupFunction() + "/mersyKpiGroupFunctionGroups";
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.Tree_Response_State = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.Tree_Response_State = - 1;
                Utils.writeLog(http, baseUrl, error);

            });
    }

    public static httpGetUserMgmtBranches(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/enrichmgmtBranches/" + userId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.Tree_Response_State = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.Tree_Response_State = - 1;
                Utils.writeLog(http, baseUrl, error);

            });
    }
    public static httpGetFieldManagementIds(http: HttpClient, baseUrl: string, businessLevel: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getBranchHierarchyAPI() + "/fieldmanagementid/" + businessLevel;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    callback(tthis, result);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);

            });
    }
    public static httpGetIsAvailabelHK(http: HttpClient, baseUrl: string, HK: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getBranchHierarchyAPI() + "/isAvailableHK/" + HK;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    callback(tthis, result);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);

            });
    }
    public static GetBranchHierarchyKeyHistory(http: HttpClient, baseUrl: string, HK: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getBranchHierarchyAPI() + "/brachHierarchyHistory/" + HK;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    callback(tthis, result);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);

            });
    }

    public static httpUpdateFieldManagementIds(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getBranchHierarchyAPI() + "/updatemgmnt";
        http
            .put(url, body).subscribe((result) => {
                if (tthis && callback) {
                    callback(tthis, result);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);

            });
    }

    public static httpClearCacheByUser(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined, isDataAnalytStage = false) {

        const url = baseUrl + Utils.getUMPUser() + "/user/" + userId + '/clearcache' + '/' + isDataAnalytStage;
        http
            .delete(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis);
                }
            }, error => {
                tthis.isCallSucceed = - 1;
                Utils.writeLog(http, baseUrl, error);
            });
    }

    public static httpEnableDisablePowerBiUser(http: HttpClient, baseUrl: string, userId: string, type: number, isEnabled: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined, selectedEmail: string | undefined = undefined) {

        let url = baseUrl + Utils.getUMPUser() + "/groupReportPowerBi/" + userId + '/' + type + '/' + isEnabled;
        if (selectedEmail) {
            url += '?selectedEmail=' + encodeURIComponent(selectedEmail);
        }
        http
            .post(url, {}).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis);
                }
            }, error => {
                tthis.isCallSucceed = - 1;
                Utils.writeLog(http, baseUrl, error);
            });
    }

    public static httpGetUserCache(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/user/" + userId + '/cache';
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.isCallSucceed = - 1;
                Utils.writeLog(http, baseUrl, error);
            });
    }

    public static httpPostPowerbiWorkspace(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_UMPUSER + "/powerbi/workspace";
        http
            .post<any>(url, body)
            .subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackerror(tthis)

            }); //console.error(error));
    }

    public static httpGetPowerbiCapacities(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_UMPUSER + "/powerbi/capacities";
        http
            .get<any>(url)
            .subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }); //console.error(error));
    }

    public static httpGetPowerbiReferenceData(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_UMPUSER + "/powerbi/referenceData";
        http
            .get<any>(url)
            .subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }); //console.error(error));
    }

    public static httpGetfieldBranchDetails(http: HttpClient, baseUrl: string, waveId: number, 
        tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/field-branch-details/' + waveId;
        tthis.subscriptions.push(http
            .get<any>(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                }, error: error => {
                    Utils.writeLog(http, baseUrl, error);
                    if (tthis && callbackError)
                        callbackError(tthis, error);
                }
            })
        );
    }
    public static httpGetAllContactCategories(http: HttpClient, baseUrl: string,
        tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/all-contact-categories';
        tthis.subscriptions.push(http
            .get<any>(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                }, error: error => {
                    Utils.writeLog(http, baseUrl, error);
                    if (tthis && callbackError)
                        callbackError(tthis, error);
                }
            })
        );
    }
    public static httpUpdateFieldBranchDetails(http: HttpClient,
        baseUrl: string, body: any,
        tthis: any | undefined = undefined,
        assessmentId: number | undefined,
        onlyDates: boolean = false,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + `/field-branch-details/${assessmentId}`+ (onlyDates ? '?onlyDates=true' : '');
        tthis.subscriptions.push(http
            .post<any>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                }, error: error => {
                    Utils.writeLog(http, baseUrl, error);
                    if (tthis && callbackError)
                        callbackError(tthis, error);
                }
            })
        );
    }

    public static httpGetKpiStageResults(http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        waveId: number,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/kpi-stage-results/' + waveId;
        http
            .get<AssessmentKpiStageResult>(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                }, error: error => {
                    Utils.writeLog(http, baseUrl, error);
                    if (tthis && callbackError)
                        callbackError(tthis, error);
                }
            })
    }

    public static httpUpdateKpiStageResults(http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        waveId: number,
        data: AssessmentKpiStageResult,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/kpi-stage-results/' + waveId;
        http
            .post<any>(url, data).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                }, error: error => {
                    Utils.writeLog(http, baseUrl, error);
                    if (tthis && callbackError)
                        callbackError(tthis, error);
                }
            })
    }

    public static httpGetAdminBranchContacts(http: HttpClient, baseUrl: string, waveId: number | undefined,
        tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + `/field-branch-contact/${waveId}`;
        tthis.subscriptions.push(http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })); //console.error(error));
    }

    public static httpUpsertContact(http: HttpClient,
        baseUrl: string,
        body: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/upsert-contact';
        http
            .post<any>(url, body).subscribe(
                {
                    next: (result) => {
                        if (tthis && callback)
                            callback(tthis, result);
                    },
                    error: error => {
                        Utils.writeLog(http, baseUrl, error);
                        callbackError(tthis, error);
                    }
                });
    }

    public static httpGetAvailableContact(http: HttpClient,
        baseUrl: string,
        waveId: number | undefined,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {
        const url = baseUrl + Utils.getBranchExcellenceAPI() + `/available-contacts/${waveId}`;
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }
    public static httpGetAllContact(http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {
        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/all-contacts';
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpAssignContact(http: HttpClient,
        baseUrl: string,
        waveId: number | undefined,
        id: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {
        const url = baseUrl + Utils.getBranchExcellenceAPI() + `/assign-contact/${waveId}/${id}`;
        http
            .post<any>(url, {}).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpUnassignContact(http: HttpClient,
        baseUrl: string,
        id: any,
        waveId: number | undefined,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + `/unassign-contact/${waveId}/${id}`;
        http
            .delete<any>(url, {}).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }
    public static httpDeleteContact(http: HttpClient,
        baseUrl: string,
        id: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/delete-contact/' + id;
        http
            .delete<any>(url, {}).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpGetExcellenceLevers(http: HttpClient, baseUrl: string,
        tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-levers';
        tthis.subscriptions.push(http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })); //console.error(error));
    }

    public static httpGetExcellenceLeversKpis(http: HttpClient, baseUrl: string,
        tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-levers-kpis';
        tthis.subscriptions.push(http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })); //console.error(error));
    }

    public static httpGetExcellenceFactors(http: HttpClient, baseUrl: string,
        tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-factors';
        tthis.subscriptions.push(http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })); //console.error(error));
    }

    public static httpGetArchetypes(http: HttpClient, baseUrl: string,
        tthis: any = undefined, callback: any = undefined, callbackError: any = undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/archetypes';
        tthis.subscriptions.push(http
            .get<any>(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (callbackError)
                        callbackError(tthis, error);
                }
            }));
    }

    public static httpGetLinesOfBusiness(http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/lines-of-business';
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpUpsertExcellenceLever(http: HttpClient,
        baseUrl: string,
        body: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-lever';
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpGetAccounts(http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/accounts';
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpUpsertExcellenceLeverKpi(http: HttpClient,
        baseUrl: string,
        body: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-lever-kpi';
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpUpsertExcellenceFactor(http: HttpClient,
        baseUrl: string,
        body: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-factor';
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }


    public static httpDeleteExcellenceLeverKpi(http: HttpClient,
        baseUrl: string,
        id: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-lever-kpi/' + id;
        http
            .delete<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpDeleteExcellenceLever(http: HttpClient,
        baseUrl: string,
        id: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-lever/' + id;
        http
            .delete<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpDeleteExcellenceFactor(http: HttpClient,
        baseUrl: string,
        id: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-factor/' + id;
        http
            .delete<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpDeleteExcellenceLevers(http: HttpClient,
        baseUrl: string,
        ids: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-levers';
        const options = {
            body: { ids }
        };
        http
            .delete<any>(url, options).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpDeleteExcellenceFactors(http: HttpClient,
        baseUrl: string,
        ids: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-factors';
        const options = {
            body: { ids }
        };
        http
            .delete<any>(url, options).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpDeleteExcellenceLeverKpis(http: HttpClient,
        baseUrl: string,
        ids: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/excellence-lever-kpis';
        const options = {
            body: { ids }
        };
        http
            .delete<any>(url, options).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpGetWaves(http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/waves';
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }
    public static httpDeleteWaves(http: HttpClient,
        baseUrl: string,
        waveid: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/waves' + '/' + waveid;
        http
            .delete<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpUpsertWave(http: HttpClient,
        baseUrl: string,
        body: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/waves';
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpGetWaveExcellenceLeverConfigurations(http: HttpClient,
        baseUrl: string,
        id: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/waves-excellence-lever-config/' + id;
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpGetUnassignedWaveExcellenceLeverConfigurations(http: HttpClient,
        baseUrl: string,
        id: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/unassigned-waves-excellence-lever-config/' + id;
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpAssignWaveExcellenceLeverConfigurations(http: HttpClient,
        baseUrl: string,
        waveId: any,
        ids: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/wave-excellence-levers/' + waveId;
        http
            .post<any>(url, { 'excellenceLeverIds': ids }).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpImportExcellenceLevers(http: HttpClient,
        baseUrl: string,
        sourceWaveId: any,
        targetWaveId: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = `${baseUrl}${Utils.getBranchExcellenceAPI()}/import-wave-excellence-levers/${sourceWaveId}/${targetWaveId}`;
        http
            .post<any>(url, {}).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpUnassignWaveExcellenceLeverConfigurations(http: HttpClient,
        baseUrl: string,
        waveId: any,
        ids: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/unassign-wave-excellence-levers/' + waveId;
        http
            .post<any>(url, { 'excellenceLeverIds': ids }).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpGetAssessments(http: HttpClient,
        baseUrl: string,
        id: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/assessment/' + id;
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpAssignBranchesToWave(http: HttpClient,
        baseUrl: string,
        waveId: any,
        branchIds: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/assessment/' + waveId;
        http
            .post<any>(url, { 'branchIds': branchIds }).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpUnassignBranchesToWave(http: HttpClient,
        baseUrl: string,
        waveId: any,
        branchIds: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/unassign-assessment/' + waveId;
        http
            .post<any>(url, { 'branchIds': branchIds }).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpGetAssessmentInformation(http: HttpClient,
        baseUrl: string,
        wave: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/assessment-information/' + wave;
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpGetFieldManagementIdsFromBranchExcellence(http: HttpClient, baseUrl: string, businessLevel: string, waveId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + "/fieldmanagementid/" + businessLevel + '/' + waveId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    callback(tthis, result);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);

            });
    }

    public static httpGetFieldManagementIdsFromOsh(http: HttpClient, baseUrl: string, businessLevel: string, waveId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getOshAPI() + "/fieldmanagementid/" + businessLevel + '/' + waveId;
        http
            .get(url).subscribe({
                next: (result) => {
                    if (tthis && callback) {
                        callback(tthis, result);
                    }
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                }
            });
    }

    public static httpPostAssessmentInformation(http: HttpClient,
        baseUrl: string,
        waveId: number,
        data: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/assessment-information/' + waveId;
        http
            .post<any>(url, data).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                if (tthis && callbackError)
                    callbackError(tthis, error);
            })
    }

    public static httpGetExcellenceStages(http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/stages';
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpGetPriorities(http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/assessment/priorities';
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpGetAllWavesByFieldBranchId(http: HttpClient, baseUrl: string, fieldBranchId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_BRANCHEXCELLENCE + "/waves/" + fieldBranchId;
        return http.get<Wave[]>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }

    public static httpGetAssessmentLeverHistory(http: HttpClient, baseUrl: string, waveExcellenceLeverConfigId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + API_BRANCHEXCELLENCE + "/assessment-config-history/" + waveExcellenceLeverConfigId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.isCallSucceed = - 1;
                Utils.writeLog(http, baseUrl, error);
            });
    }

    public static httpGetFocusPlanInformation(http: HttpClient,
        baseUrl: string,
        wave: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/' + wave;
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpGetUnassignedKpisByFieldBranchAndWave(http: HttpClient,
        baseUrl: string,
        wave: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/unassigned-kpis/' + wave;
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpUpsertMeasure(http: HttpClient,
        baseUrl: string,
        wave: number,
        body: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/upsert-measure/' + wave;
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpUpsertActionItem(http: HttpClient,
        baseUrl: string,
        body: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/upsert-actionitem';
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }
    public static httpUpsertActionItemlist(http: HttpClient,
        baseUrl: string,
        body: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/upsert-actionitemlist';
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpUpsertMeasureStatusQXList(http: HttpClient,
        baseUrl: string,
        body: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/upsert-measurestatusqxlist';
        http
            .post<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpDeleteMeasure(http: HttpClient,
        baseUrl: string,
        measureId: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/measure/' + measureId;
        http
            .delete<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpDeleteActionItem(http: HttpClient,
        baseUrl: string,
        actionItemId: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/actionitem/' + actionItemId;
        http
            .delete<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpGetAvailableStatuses(http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/statuses';
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpUpsertActionItemStatuses(http: HttpClient,
        baseUrl: string,
        data: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/upsert-actionitemstatus';
        http
            .post<any>(url, data).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpGetAvailableStatusesQX(http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/statusesQX';
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }); //console.error(error));
    }

    public static httpGetFocusPlanImpact(http: HttpClient,
        baseUrl: string,
        wave: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/impact/' + wave;
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpUpsertFinancialImpact(http: HttpClient,
        baseUrl: string,
        wave: number,
        data: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + '/focus-plan/upsert-impact/' + wave;
        http
            .post<any>(url, data).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpGetPatternDefinition(http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getGlobalTaskListAPI() + '/pattern-definitions';
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpGetPatternTasks(http: HttpClient,
        baseUrl: string,
        patternDefinitionId: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getGlobalTaskListAPI() + '/' + patternDefinitionId + '/pattern-tasks';
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpGetUrlsSupport(http: HttpClient,
        baseUrl: string,
        patternTaskId: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getGlobalTaskListAPI() + '/' + patternTaskId + '/url-supports';
        http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpMergePatternDefinition(http: HttpClient,
        baseUrl: string,
        data: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getGlobalTaskListAPI() + '/pattern-definitions';
        http
            .post<any>(url, data).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpMergePatternTask(http: HttpClient,
        baseUrl: string,
        data: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getGlobalTaskListAPI() + '/pattern-tasks';
        http
            .post<any>(url, data).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpMergeUrlSupport(http: HttpClient,
        baseUrl: string,
        data: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getGlobalTaskListAPI() + '/urls-support';
        http
            .post<any>(url, data).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpDeletePatternDefinition(http: HttpClient,
        baseUrl: string,
        patternDefinitionId: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getGlobalTaskListAPI() + '/pattern-definitions/' + patternDefinitionId;
        http
            .delete<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpDeletePatternTask(http: HttpClient,
        baseUrl: string,
        patternTaskId: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getGlobalTaskListAPI() + '/pattern-tasks/' + patternTaskId;
        http
            .delete<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    public static httpDeleteUrlSupport(http: HttpClient,
        baseUrl: string,
        urlPatternTaskId: number,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined) {

        const url = baseUrl + Utils.getGlobalTaskListAPI() + '/urls-support/' + urlPatternTaskId;
        http
            .delete<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            })
    }

    /**
     * return a not translated class style, if text is null, undefined or includes 'en-US'
     * @param text - text do verify
     */
    public static notTranslatedClass(text: string): string {
        if (text == null || text == undefined || text.includes("en-US_"))
            return NOT_TRANSLATED_CLASSNAME; //"not-translated";
        return "";
    }



    //public static redirectLogout(http: HttpClient, baseUrl: string) {
    //    const url = baseUrl + API_GENERIC + "logout";
    //    const logout = baseUrl + 'logout';
    //    const logout2 = "https://login.microsoftonline.com/2edb9c97-3a5c-4c4c-9b88-da2b5f3568b8/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:44326";

    //    //this.httpGetPostRedirectUrl(http, baseUrl, this, function (tthis: any, value: string) {
    //    //    tthis.postLogoutRedirectUrl = value;
    //    //});
    //    let postLogoutRedirectUrl = '';

    //    http.get(baseUrl + API_GENERIC + 'postlogoutredirecturl').subscribe(data => {
    //        console.log(data);
    //        // postLogoutRedirectUrl = data;
    //    })

    //    http
    //        .post<Elevator>(url, null)
    //        .subscribe(
    //            res => {
    //                // window.location.href = logout2;
    //                http.get(logout2).subscribe(() => {
    //                    console.log("test");
    //                });

    //            }, error => {
    //                window.location.href = logout2;
    //            }
    //        );

    //    http.get(logout).subscribe(result => {
    //        console.log(result);
    //        window.location.href = logout2;
    //    });

    //}

    public static redirectLogout(redirectUrl: string) {
        window.location.href = redirectUrl;
    }

    public static httpGetPostRedirectUrl(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_GENERIC + "postlogoutredirecturl";
        http.get<string>(url).subscribe(result => {
            if (tthis && callback)
                callback(tthis, result);
        }, error => {
            Utils.writeLog(http, baseUrl, error);
        });
    }

    public static httpGetUserHistory(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/user/" + userId + '/history';
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.isCallSucceed = - 1;
                Utils.writeLog(http, baseUrl, error);
            });
    }

    public static httpGetComponentFunctionTypes(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEMTAPI() + '/functionTypes';
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetComponentFamilyCodes(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEMTAPI() + '/familyCodes';
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetMfgcenters(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEMTAPI() + '/mfgcenters';
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetBomCodes(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEMTAPI() + '/bomcodes';
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetEMTControllerSoftwareReleases(http: HttpClient, baseUrl: string, isContractSpecific?: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        let url = baseUrl + Utils.getEMTAPI() + '/controllersoftware';
        if (typeof isContractSpecific === 'boolean') {
            url += `?isContractSpecific=${isContractSpecific}`;
        }
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetEMTControllerSoftwareReleaseById(http: HttpClient, baseUrl: string, controllerSoftwareVersionID: number, isContractSpecific?: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        let url = baseUrl + Utils.getEMTAPI() + '/controllersoftware/' + controllerSoftwareVersionID;
        if (typeof isContractSpecific === 'boolean') {
            url += `?isContractSpecific=${isContractSpecific}`;
        }
        http
            .get(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { 
                    Utils.writeLog(http, baseUrl, error);
                    if (tthis && callback)
                        callback(tthis, { error: true, errorMssg: error?.error?.error || error?.message || 'Failed to get controller software'  });
                }
            });
    }

    public static httpGetJCOBReleaseFiles(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getJCOBAPI() + '/jcobrulefiles';
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetJCOBReleaseFileContent(http: HttpClient, baseUrl: string, ruleFileId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getJCOBAPI() + '/jcobrulefilecontent/' + ruleFileId;
        http
            .get(url, { responseType: 'text' }).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetNVStruct(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getJCOBAPI() + '/nvstruct';
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpDownloadNVStructFile(http: HttpClient, baseUrl: string, nvStructSchemaId: number, callback: (blob: Blob) => void) {
        const url = baseUrl + Utils.getJCOBAPI() + `/nvstruct/${nvStructSchemaId}/download`;
        http
            .get(url, { responseType: 'blob' }).subscribe({
                next: (blob) => callback(blob),
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpDownloadCommandFile(http: HttpClient, baseUrl: string, jCobCommandId: number, callback: (blob: Blob) => void) {
        const url = baseUrl + Utils.getJCOBAPI() + `/jcobcommandfile/${jCobCommandId}/download`;
        http
            .get(url, { responseType: 'blob' }).subscribe({
                next: (blob) => callback(blob),
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetJcobCommandFiles(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getJCOBAPI() + '/jcobcommandfiles';
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetEMTProductsUsage(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEMTAPI() + '/productUsage';
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetEMTPeripheralSoftwareVersions(http: HttpClient, baseUrl: string, isContractSpecific?: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        let url = baseUrl + Utils.getEMTAPI() + '/peripheralsoftware';
        if (typeof isContractSpecific === 'boolean') {
            url += `?isContractSpecific=${isContractSpecific}`;
        }
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetMfgCenterProducts(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEMTAPI() + '/mfgcenterproducts';
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpGetControllerSoftwareForConfigGeneration(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEMTAPI() + '/softwareVersionForConfigGeneration';
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }


    public static httpUpdateEMTProductsUsage(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getEMTAPI() + "/updateProductUsage";
        http
            .put<string>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        tthis.isCallSucceed = 1;
                    callback(tthis, result);
                },
                error: (error) => {
                    tthis.isCallSucceed = -1;
                    Utils.writeLog(http, baseUrl, error);
                    callback(tthis);
                }
            });
    }

    public static httpUpdateControllerSoftwareReleases(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEMTAPI() + '/updateControllerSoftware';
        http
            .put<string>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        tthis.isCallSucceed = 1;
                    callback(tthis, result);
                },
                error: (error) => {
                    tthis.isCallSucceed = -1;
                    Utils.writeLog(http, baseUrl, error);
                    callback(tthis);
                }
            });
    }

    public static httpUploadControllerSoftwareModelFile(
        http: HttpClient,
        baseUrl: string,
        formData: FormData,
        familyCode: string,
        tthis: any,
        callback: Function
    ) {
        http.post(baseUrl + Utils.getEMTAPI() + '/uploadModelFile?familyCode=' + familyCode, formData)
            .subscribe({
                next: (result: any) => callback(tthis, result),
                error: (error: any) => callback(tthis, { error: true, errorMssg: error?.message || 'Upload failed' })
            });
    }

    public static httpDownloadControllerSoftwareModelFile(
        http: HttpClient,
        baseUrl: string,
        modelFileId: number,
        tthis: any,
        callback: Function
    ) {
        http.get(baseUrl + Utils.getEMTAPI() + '/download/' + modelFileId, { responseType: 'text' })
            .subscribe({
                next: (result: string) => callback(tthis, result),
                error: (error: any) => callback(tthis, { error: true, errorMssg: error?.message || 'Download failed' })
            });
    }

    public static httpUpdateControllerSoftwareModelFile(
        http: HttpClient,
        baseUrl: string,
        controllerSoftwareReleaseId: number,
        modelFileId: number,
        tthis: any,
        callback: Function
    ) {
        const url = baseUrl + Utils.getEMTAPI() + '/updateModelFile';
        const body = {
            controllerSoftwareReleaseId: controllerSoftwareReleaseId,
            modelFileId: modelFileId
        };
        http.put(url, body)
            .subscribe({
                next: (result: any) => callback(tthis, result),
                error: (error: any) => callback(tthis, { error: true, errorMssg: error?.message || 'Update failed' })
            });
    }

    public static httpUpdateModelFileReleaseName(
        http: HttpClient,
        baseUrl: string,
        modelFileId: number,
        releaseName: string,
        tthis: any,
        callback: Function
    ) {
        const url = baseUrl + Utils.getEMTAPI() + '/updateModelFileReleaseName';
        const body = {
            modelFileId: modelFileId,
            releaseName: releaseName
        };
        http.put(url, body)
            .subscribe(
                (result: any) => callback(tthis, result),
                (error: any) => callback(tthis, { error: true, errorMssg: error?.message || 'Update failed' })
            );
    }

    public static httpUpdateModelFileComment(
        http: HttpClient,
        baseUrl: string,
        modelFileId: number,
        comment: string,
        tthis: any,
        callback: Function
    ) {
        const url = baseUrl + Utils.getEMTAPI() + '/updateModelFileComment';
        const body = {
            modelFileId: modelFileId,
            comment: comment
        };
        http.put(url, body)
            .subscribe(
                (result: any) => callback(tthis, result),
                (error: any) => callback(tthis, { error: true, errorMssg: error?.message || 'Update failed' })
            );
    }

    public static httpUpdateJCOBRuleFiles(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getJCOBAPI() + '/jcobrulefiles';
        http
            .put<string>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        tthis.isCallSucceed = 1;
                    callback(tthis, result);
                },
                error: (error) => {
                    tthis.isCallSucceed = -1;
                    Utils.writeLog(http, baseUrl, error);
                    callback(tthis);
                }
            });
    }
    public static httpUpdateNVStruct(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getJCOBAPI() + '/nvstruct';
        http
            .post<string>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        tthis.isCallSucceed = 1;
                    callback(tthis, result);
                },
                error: (error) => {
                    tthis.isCallSucceed = -1;
                    Utils.writeLog(http, baseUrl, error);
                    callback(tthis);
                }
            });
    }
    public static httpUpdateJcobCommandFiles(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getJCOBAPI() + '/jcobcommandfiles';
        http
            .post<string>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        tthis.isCallSucceed = 1;
                    callback(tthis, result);
                },
                error: (error) => {
                    tthis.isCallSucceed = -1;
                    Utils.writeLog(http, baseUrl, error);
                    callback(tthis);
                }
            });
    }

    public static httpUpdatePeripheralSoftwareVersions(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEMTAPI() + '/updatePeripheralSoftware';
        http
            .put<string>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        tthis.isCallSucceed = 1;
                    callback(tthis, result);
                },
                error: (error) => {
                    tthis.isCallSucceed = -1;
                    Utils.writeLog(http, baseUrl, error);
                    callback(tthis);
                }
            });
    }

    public static httpUpdateCenterProducts(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEMTAPI() + '/updateCenterProduct';
        http
            .put<string>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        tthis.isCallSucceed = 1;
                    callback(tthis, result);
                },
                error: (error) => {
                    tthis.isCallSucceed = -1;
                    Utils.writeLog(http, baseUrl, error);
                    callback(tthis);
                }
            });
    }

    public static httpUpdateControllerSoftwareConfigGeneration(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getEMTAPI() + '/updateControllerSoftwareConfigGeneration';
        http
            .put<string>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        tthis.isCallSucceed = 1;
                    callback(tthis, result);
                },
                error: (error) => {
                    tthis.isCallSucceed = -1;
                    Utils.writeLog(http, baseUrl, error);
                    callback(tthis);
                }
            });
    }


    public static httpUpdateComponentFunctionTypes(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getEMTAPI() + "/updateFT";
        http
            .put<string>(url, body).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.isCallSucceed = -1;
                callback(tthis);
            });
    }

    public static httpUpdateComponentFamilyCodes(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getEMTAPI() + "/updateFC";
        http
            .put<string>(url, body).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.isCallSucceed = -1;
                callback(tthis);
            });
    }

    public static httpUpdateBOMCodes(http: HttpClient, baseUrl: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getEMTAPI() + "/updateBOMCodes";
        http
            .put<string>(url, body).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis);
                }
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                tthis.isCallSucceed = -1;
                callback(tthis);
            });
    }

    public static httpGetMarketQueryInformation(http: HttpClient, baseUrl: string, type: string, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = baseUrl + Utils.getMarketQueryAPI() + '/' + type;
        tthis.subscriptions.push(http
            .get<any>(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    callbackError(tthis, error);
                }
            }));
    }

    public static httpUpdateMarketQueryInformation(http: HttpClient, baseUrl: string, marketQueryType: string, body: any, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = `${baseUrl}${Utils.getMarketQueryAPI()}/${marketQueryType}`;
        tthis.subscriptions.push(http
            .post<any>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    callbackError(tthis, error);
                }
            }));
    }

    public static httpReleaseMarketQueryInfo(http: HttpClient, baseUrl: string, body: any, isMarketSheet: boolean, tthis?: any, callback?: any, callbackError?: any) {

        const url = `${baseUrl}${Utils.getMarketQueryAPI()}/release/${isMarketSheet}`;
        http
            .put<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLogOrCallbackError(http, baseUrl, error, tthis, callbackError);
            }); //console.error(error));
    }

    public static httpRevokeMarketQueryInfo(http: HttpClient, baseUrl: string, body: any, isMarketSheet: boolean, tthis?: any, callback?: any, callbackError?: any) {

        const url = `${baseUrl}${Utils.getMarketQueryAPI()}/revoke/${isMarketSheet}`;
        http
            .put<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLogOrCallbackError(http, baseUrl, error, tthis, callbackError);
            }); //console.error(error));
    }

    public static httpUpdateMgmtBranchHierarchyGroupFunctions(http: HttpClient, baseUrl: string, body: any, tthis: Editgroupfunctionsdialogue, callback: any, callbackError: any) {

        const url = `${baseUrl}${Utils.getUMPUser()}/updateMgmtHierarchyRefGroupFunctions`;
        tthis.subscriptions.push(http
            .post<any>(url, body).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    callbackError(tthis, error);
                }
            }));
    }

    public static httpDownloadMgmtHierarchyRefGroupFunctions(http: HttpClient, baseUrl: string, tthis: any = undefined, callbackError: any = undefined) {

        const url = `${baseUrl}${Utils.getUMPUser()}/downloadMgmtHierarchyRefGroupFunctions`;
        http
            .get(url, { responseType: 'blob' }).subscribe({
                next: (response: any) => {
                    this.downloadFile(response, 'GroupFunctions', 'xlsx');
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (tthis && callbackError)
                        callbackError(tthis, error);
                }
            });
    }

    /**
     * stop propagation on an event
     * 
     * @param event
     */
    public static stopPropagation(event: any) {
        event.stopPropagation();
    }


    ///**
    // * 
    // * @param ct
    // * @deprecated
    // */
    //public static setControllerType(ct: ControllerType) { this.controllertype = ct; }

    ///**
    // * 
    // * @param lang
    // * @deprecated
    // */
    //public static setLanguage(lang: Language) { this.language = lang; }

    ///**
    // * show dialogs confirm, the object that uses must have the fields type; message; classdialog and classname
    // * change classname for alert and form
    // * @param tthis
    // * @param question
    // * @deprecated
    // */
    //public static showConfirmDialog(tthis: any, question: string, title: string = "") {
    //    tthis.title = title;
    //    tthis.type = this.getConfirmValue();
    //    tthis.message = question;        
    //    this.showDialog(tthis);
    //}

    ///**
    // * show dialogs confirm, the object that uses must have the fields type; message; classdialog and classname
    // * change classname for alert and form
    // * @param tthis
    // * @param question
    // * @deprecated
    // */
    //public static showConfirmDialog2(tthis: any, question: string, title: string = "") {
    //    //tthis.type = this.getConfirmValue();
    //    //tthis.message = question;
    //    tthis.SetTitle(title);
    //    this.showDialog(tthis);
    //}

    ///**
    // * show dialogs confirm, the object that uses must have the fields type; message; classdialog and classname
    // * change classname for alert and form
    // * @param tthis
    // * @param question
    // */
    //public static showErrorDialog(tthis: any, error: any) {
    //    if ((error.status == 200 && tthis == null) || error.status == STATUS_SERVER_ERROR_CODE) {
    //        Utils.redirectLogout();//window.location.href = "https://login.microsoftonline.com/common/oauth2/logout"; //?post_logout_redirect_uri=http%3A%2F%2Flocalhost%2Fhome%2F"; //error.url + "/logout";

    //        //console.debug("We HAVE an ERROR!!!!!");
    //        //console.error(error);
    //    }
    //    else {
    //        tthis.type = this.getErrorValue();
    //        tthis.title = "Error";
    //        tthis.message = error.error.message;
    //        this.showDialog(tthis);
    //    }
    //}


    /**
     * write to log and redirect if we have a 509 error code
     * change classname for alert and form
     * @param tthis
     * @param question
     */
    public static writeLog(http: HttpClient, baseUrl: string, error: any) {
        console.error(error);
        if (
            error.status == STATUS_SERVER_ERROR_CODE ||
            error.status == UNAUTHORIZED_SERVER_ERROR
        ) {
            Utils.redirectLogout('');
        }
    }

    private static writeLogOrCallbackError(http: HttpClient, baseUrl: string, error: any, tthis: any, callbackError: any) {
        if (tthis && callbackError && error.status != UNAUTHORIZED_SERVER_ERROR) {
            console.error(error);
            callbackError(tthis, error);
            return;
        }
        Utils.writeLog(http, baseUrl, error);
    }

    public static extractErrorMessage(error: any): string {
        if (!error) return '';
        const body = error.error;

        if (Utils.isNonEmptyString(body)) return body;

        if (body && typeof body === 'object') {
            const fromKnown = Utils.tryKnownErrorProps(body);
            if (fromKnown) return fromKnown;

            const fromErrors = Utils.tryProblemDetailsErrors(body.errors);
            if (fromErrors) return fromErrors;

            const fromModelState = Utils.tryModelStateDict(body);
            if (fromModelState) return fromModelState;
        }

        if (Utils.isNonEmptyString(error.message)) return error.message;
        return '';
    }

    private static isNonEmptyString(v: any): v is string {
        return typeof v === 'string' && v.trim() !== '';
    }

    private static tryKnownErrorProps(body: any): string {
        if (Utils.isNonEmptyString(body.detail)) return body.detail;
        if (Utils.isNonEmptyString(body.title)) return body.title;
        if (Utils.isNonEmptyString(body.message)) return body.message;
        return '';
    }

    private static tryProblemDetailsErrors(errors: any): string {
        if (!errors || typeof errors !== 'object') return '';
        const messages: string[] = [];
        for (const key of Object.keys(errors)) {
            const val = errors[key];
            if (Array.isArray(val)) messages.push(...val);
            else if (typeof val === 'string') messages.push(val);
        }
        return messages.join(' ');
    }

    private static tryModelStateDict(body: any): string {
        const messages: string[] = [];
        for (const key of Object.keys(body)) {
            const val = body[key];
            if (Array.isArray(val) && val.every(v => typeof v === 'string')) {
                messages.push(...val);
            }
        }
        return messages.join(' ');
    }

    public static downloadBlobFile(Blobdata: any, fileNameDotType: string) {
        const url = window.URL.createObjectURL(Blobdata);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileNameDotType;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    public static isGUIDvalid(guid: string): boolean {
        return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(guid);
    }

    public static downloadFile(response: any, filename: string, extension: string) {
        let dataType = response.type;
        let binaryData: any[] = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        downloadLink.setAttribute('download', filename + '.' + extension);
        document.body.appendChild(downloadLink);
        downloadLink.click();
    }

    public static base64ToBlob(b64Data: any, contentType = '', sliceSize = 512) {
        b64Data = b64Data.replace(/\s/g, ''); //IE compatibility...
        let byteCharacters = atob(b64Data);
        let byteArrays: Uint8Array[] = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);

            let byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    }

    private static encodeSlashes(text: string): string {
        return text.replace('/', '$_$')
    }

    public static OmitKeysSpreadOperator = (keys: any[], obj: any) => Object.entries(obj)
        .filter(([key]) => !keys.includes(key))
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

    public static RemoveBlankFields = (obj: any) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null))

    public static deepCopyArray(array: any) {
        const copiedArray: any[] = [];

        for (let i = 0; i < array.length; i++) {
            if (Array.isArray(array[i])) {
                copiedArray[i] = this.deepCopyArray(array[i]); // Llamada recursiva para copiar subarrays
            } else if (typeof array[i] === 'object' && array[i] !== null) {
                copiedArray[i] = Object.assign({}, array[i]); // Copia el objeto utilizando Object.assign()
            } else {
                copiedArray[i] = array[i]; // Copia el valor primitivo
            }
        }

        return copiedArray;
    }

    public static deepCopy(obj: any): any {
        if (Array.isArray(obj)) {
            const copyArr: any[] = [];
            for (const item of obj) {
                copyArr.push(this.deepCopy(item));
            }
            return copyArr;
        } else if (typeof obj === 'object' && obj !== null) {
            const copyObj: Record<string, any> = {};
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    copyObj[key] = this.deepCopy(obj[key]);
                }
            }
            return copyObj;
        } else {
            return obj;
        }
    }

    public static deepCopyExcludingProperty(obj: any, propertyToExclude: string): any {
        if (obj && propertyToExclude in obj) {
            const { [propertyToExclude]: _, ...restOfObject } = obj;
            return { ...restOfObject, 'Groups': [] };
        } else {
            return { ...obj };
        }
    }

    public static GetManagementChildrenByParent(group: ManagementId, branchId: string): ManagementId | null {
        if (!group.GroupName || !group.Value?.includes(branchId)) {
            if (group.Groups) {
                for (const child of group.Groups) {
                    const result = Utils.GetManagementChildrenByParent(child, branchId);
                    if (result !== null) {
                        return result;
                    }
                }
            }
            return null;
        }

        return group;
    }

    public static hasAdditionalLicenseCost(persona: string): number {
        if (persona.toLowerCase().includes("_test") || persona.toLowerCase().includes("powerbi pro"))
            return 1;
        if (persona.toLowerCase().includes("_basic"))
            return 0;
        return -1;
    }

    public static getDomainByWindowLocation(): string {
        const currentUrl = window.location.href.toLowerCase();
        const urlObject = new URL(currentUrl);
        const path = urlObject.pathname;
        // Allows switching App from frontend.
        // Usage: http://localhost:4200/rulebook
        if (path.includes('rulebook')) {
            return 'rulebook';
        } else if (path.includes('mersy')) {
            return 'mersy';
        } else {
            return urlObject.hostname;
        }
    }

    public static dateUTCchange(event: MatDatepickerInputEvent<Date>): Date {
        const localDate = event.value;
        if (localDate) {
            return this.convertToUTC(localDate);
        }
        else
            return new Date();
    }

    private static convertToUTC(date: Date): Date {
        const offset = date.getTimezoneOffset();

        if (offset > 0) {
            return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        }
        else if (offset < 0) {
            return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        }
        else
            return date;
    }

    public static IsValidNumber(figure: string | number): boolean {
        if (typeof figure === 'number' && !isNaN(figure)) {
            return true;
        }

        if (typeof figure === 'string') {
            const numStr = figure.trim();

            if (numStr === '' || numStr === '.' || numStr === '-' || numStr === '+') {
                return false;
            }

            const num = Number(numStr);
            return !isNaN(num);
        }

        return false;
    }

    public static ConfigurationKeyEnumTypeDescriptions: { [key in ConfigurationKeyEnumType]: string } = {
        [ConfigurationKeyEnumType.NoConsequence]: "No Consequence",
        [ConfigurationKeyEnumType.Shutdown]: "Shutdown",
    };

    public static async readBlobError(error): Promise<string> {
        let errorMessage = '';

        if (error.error instanceof Blob) {
            const reader = new FileReader();
            return new Promise((resolve, reject) => {
                reader.onload = (e: any) => {
                    errorMessage = `Error: ${e.target.result}`;
                    resolve(errorMessage);
                };
                reader.onerror = (e) => {
                    reject('Error reading blob');
                };
                reader.readAsText(error.error);
            });
        } else {
            return Promise.resolve('Unknown error');
        }
    }

    public static httpGetBranchExcellenceChangelog(http: HttpClient, baseUrl: string, section: string, id: number, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getBranchExcellenceAPI() + "/branch-excellence-changelog/" + section + "/" + id;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.isCallSucceed = - 1;
                Utils.writeLog(http, baseUrl, error);
            });
    }

    public static httpDeleteNiOpsReportingData(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getNiOpsReportingAPI() + "/niops-reporting";
        http
            .delete(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.isCallSucceed = - 1;
                Utils.writeLog(http, baseUrl, error);
            });
    }

    public static httpGetMeasureHistory(http: HttpClient, baseUrl: string, measureId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined = undefined) {
        const url = baseUrl + Utils.getBranchExcellenceAPI() + "/focus-plan/measure-history/" + measureId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.isCallSucceed = -1;
                Utils.writeLog(http, baseUrl, error);
                if (callbackError) {
                    callbackError(tthis, error);
                }
            });
    }

    public static httpGetActionItemHistory(http: HttpClient, baseUrl: string, actionItemId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined = undefined) {
        const url = baseUrl + Utils.getBranchExcellenceAPI() + "/focus-plan/action-item-history/" + actionItemId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.isCallSucceed = -1;
                Utils.writeLog(http, baseUrl, error);
                if (callbackError) {
                    callbackError(tthis, error);
                }
            });
    }

    public static httpGetMeasureStatusHistory(http: HttpClient, baseUrl: string, measureId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined = undefined) {
        const url = baseUrl + Utils.getBranchExcellenceAPI() + "/focus-plan/measure-status-history/" + measureId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.isCallSucceed = -1;
                Utils.writeLog(http, baseUrl, error);
                if (callbackError) {
                    callbackError(tthis, error);
                }
            });
    }

    public static httpGetActionItemStatusHistory(http: HttpClient, baseUrl: string, actionItemId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined = undefined) {
        const url = baseUrl + Utils.getBranchExcellenceAPI() + "/focus-plan/action-item-status-history/" + actionItemId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.isCallSucceed = -1;
                Utils.writeLog(http, baseUrl, error);
                if (callbackError) {
                    callbackError(tthis, error);
                }
            });
    }

    public static httpGetCustomerDocuments(http: HttpClient, baseUrl: string, stage: number, body: CustomerDocumentFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + Utils.getInfoHubAPI() + "customerdocuments/" + stage;
        tthis.subscriptions.push(http
            .post<any>(url, body).subscribe(result => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
            }));
    }

    public static httpGetDetailedCustomerDocument(http: HttpClient, baseUrl: string, stage: number, customerDocument: CustomerDocument, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "customerdocumentdetails/" + stage
        const body = {
            DocumentId: customerDocument.DocumentId,
            CustomerId: customerDocument.CustomerId,
            ContractNumber: customerDocument.ContractNumber,
            UnitId: customerDocument.UnitId
        }
        http
            .post<any>(url, body).subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
            });
    }

    public static httpUpdateCustomerDocuments(http: HttpClient, baseUrl: string, stage: number, customerdocuments: CustomerDocument[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined = undefined) {
        const url = baseUrl + API_INFOHUB + "customerdocuments" + "/" + stage;
        http
            .put<CustomerDocument>(url, customerdocuments)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackError)
                    callbackError(tthis, error)
            });
    }

    public static httpDownloadCustomerDocuments(http: HttpClient, baseUrl: string, stage: number, tenantId: string, body: CustomerDocumentFilter, tthis: any | undefined = undefined, callback: any | undefined = undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/customerdocuments?stage=" + stage + "&filename=customerdocuments";
        http.post(url, body, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, tenantId + '_CustomerDocuments', "xlsx")
        });
    }

    public static httpUpdateTaxKpis(http: HttpClient, baseUrl: string, updatedKpis: TaxKpiManagementUpdate[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined = undefined) {
        const url = baseUrl + Utils.getTAXAPI() + "/taxkpis";
        http
            .post<TaxKpiManagementUpdate[]>(url, updatedKpis)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackError)
                    callbackError(tthis, error)
            });
    }

    public static httpReleaseTaxKpiDefinitions(http: HttpClient, baseUrl: string, body: any, isActual: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getTAXAPI() + '/release/' + isActual;
        http
            .put<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpRevokeTaxKpiValues(http: HttpClient, baseUrl: string, body: any, isActual: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getTAXAPI() + '/revoke/' + isActual;
        http
            .put<any>(url, body).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error); //Utils.showErrorDialog(null, error);

            }); //console.error(error));
    }

    public static httpDownloadTaxActualReportingInformation(http: HttpClient, baseUrl: string, file_name: string, showAll: boolean, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/taxactualreporting/" + showAll;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, file_name, "xlsx"),
                (error: any) => {
                    Utils.writeLog(http, baseUrl, error);
                    callbackError(tthis, error);
                }
        });
    }

    public static httpGetTaxActualReportingInformation(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = baseUrl + Utils.getTAXAPI() + '/taxkpiall';
        tthis.subscriptions.push(http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }));
    }

    public static httpUpdateTaxKpisYearlyPlanning(http: HttpClient, baseUrl: string, updatedKpis: TaxKpiManagementUpdate[], tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined = undefined) {
        const url = baseUrl + Utils.getTAXAPI() + "/taxkpioplyearly";
        http
            .post<TaxKpiManagementUpdate[]>(url, updatedKpis)
            .subscribe(res => {
                if (tthis && callback)
                    callback(tthis, res);
            }, error => {
                if (callbackError)
                    callbackError(tthis, error)
            });
    }

    public static httpGetTaxYearlyPlanningInformation(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined) {

        const url = baseUrl + Utils.getTAXAPI() + '/taxkpioplyearly';
        tthis.subscriptions.push(http
            .get<any>(url).subscribe((result) => {
                if (tthis && callback)
                    callback(tthis, result);
            }, error => {
                Utils.writeLog(http, baseUrl, error);
                callbackError(tthis, error);
            }));
    }

    public static httpDownloadYearlyOPLTaxInformation(http: HttpClient, baseUrl: string, file_name: string, showAll: boolean, tthis: any | undefined = undefined, callbackError: any | undefined) {
        const url = baseUrl + API_EXPORTIMPORT + "download/taxkpioplyearly/" + showAll;
        http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
            this.downloadFile(response, file_name, "xlsx"),
                (error: any) => {
                    Utils.writeLog(http, baseUrl, error);
                    callbackError(tthis, error);
                }
        });
    }

    public static httpGetMeasureTargetHistory(http: HttpClient, baseUrl: string, measureId: number, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackError: any | undefined = undefined) {
        const url = baseUrl + Utils.getBranchExcellenceAPI() + "/focus-plan/measure-target-history/" + measureId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.isCallSucceed = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.isCallSucceed = -1;
                Utils.writeLog(http, baseUrl, error);
                if (callbackError) {
                    callbackError(tthis, error);
                }
            })
    }
    public static httpGetUserCDPGroups(http: HttpClient, baseUrl: string, userId: string, tthis: any | undefined = undefined, callback: any | undefined = undefined) {

        const url = baseUrl + Utils.getUMPUser() + "/enrichCdpGroups/" + userId;
        http
            .get(url).subscribe((result) => {
                if (tthis && callback) {
                    tthis.Tree_Response_State = 1;
                    callback(tthis, result);
                }
            }, error => {
                tthis.Tree_Response_State = - 1;
                Utils.writeLog(http, baseUrl, error);

            });
    }

    public static httpGetAllDeviceTypesAndModels(http: HttpClient, baseUrl: string, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {
        const url = baseUrl + API_DIGITALSERVICES + "/getDeviceTypesAndModels";
        return http.get<Feature[]>(url).subscribe({
            next: result => {
                if (tthis && callback)
                    callback(tthis, result);
            },
            error: error => {
                if (tthis && callbackerror)
                    callbackerror(tthis, error);
            }
        });
    }

    public static httpPostUploadNewFirmwareDeviceTypeAndModels(http: HttpClient, baseUrl: string, body: FormData, tthis: any | undefined = undefined, callback: any | undefined = undefined, callbackerror: any | undefined = undefined) {

        const url = baseUrl + API_DIGITALSERVICES + "/newFirmware";
        http
            .post<any>(url, body).subscribe({
                next: result => {
                    if (tthis && callback) {
                        tthis.isCallSucceed = 1;
                        callback(tthis, result);
                    }
                },
                error: error => {
                    Utils.writeLog(http, baseUrl, error);
                    tthis.isCallSucceed = -1;
                    if (callbackerror)
                        callbackerror(tthis, error)
                }
            });
    }

    public static httpGetEMTGlobalControllerGroups(
        http: HttpClient,
        baseUrl: string,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined)
    {
        const url = baseUrl + Utils.getEMTAPI() + "/globalcontrollergroups";
        http
            .get(url).pipe(takeUntil(tthis.destroy$)).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => { Utils.writeLog(http, baseUrl, error); }
            });
    }

    public static httpCreateEMTGlobalControllerGroup(
        http: HttpClient,
        baseUrl: string,
        body: any,
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any |undefined = undefined)
    {
        const url = baseUrl + Utils.getEMTAPI() + '/globalcontrollergroup';
        http
            .post<any>(url, body).subscribe(
                {
                    next: (result) => {
                        if (tthis && callback)
                            callback(tthis, result);
                    },
                    error: error => {
                        Utils.writeLog(http, baseUrl, error);
                        callbackError(tthis, error);
                    }
                });
    }

    // OSH (Occupational Safety and Health) HTTP Methods
    public static httpGetOshWaves(http: HttpClient,
        baseUrl: string,
        tthis?: any,
        callback?: any,
        callbackError?: any) {

        const url = baseUrl + Utils.getOshAPI() + '/waves';
        http
            .get<any>(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (callbackError) {
                        callbackError(tthis, error);
                    }
                }
            })
    }

    public static httpDeleteOshWaves(http: HttpClient,
        baseUrl: string,
        waveid: number,
        tthis?: any,
        callback?: any,
        callbackError?: any) {

        const url = baseUrl + Utils.getOshAPI() + '/waves' + '/' + waveid;
        http
            .delete<any>(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (callbackError) {
                        callbackError(tthis, error);
                    }
                }
            })
    }

    public static httpCreateOshWave(http: HttpClient,
        baseUrl: string,
        body: any,
        tthis?: any,
        callback?: any,
        callbackError?: any) {

        const url = baseUrl + Utils.getOshAPI() + '/waves';
        http
            .post<any>(url, body).subscribe(
                {
                    next: (result) => {
                        if (tthis && callback)
                            callback(tthis, result);
                    },
                    error: error => {
                        Utils.writeLog(http, baseUrl, error);
                        callbackError(tthis, error);
                    }
                });
    }

    public static httpUpdateOshWave(http: HttpClient,
        baseUrl: string,
        body: any,
        tthis?: any,
        callback?: any,
        callbackError?: any) {

        const waveId = body.waveId || body.id;
        const url = baseUrl + Utils.getOshAPI() + '/waves/' + waveId;
        http
            .put<any>(url, body).subscribe(
                {
                    next: (result) => {
                        if (tthis && callback)
                            callback(tthis, result);
                    },
                    error: error => {
                        Utils.writeLog(http, baseUrl, error);
                        callbackError(tthis, error);
                    }
                });
    }

    public static httpGetOshWaveProtocolConfigurations(http: HttpClient,
        baseUrl: string,
        waveId: any,
        tthis?: any,
        callback?: any,
        callbackError?: any) {

        const url = baseUrl + Utils.getOshAPI() + '/waves/' + waveId + '/protocols';
        http
            .get<any>(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (callbackError) {
                        callbackError(tthis, error);
                    }
                }
            })
    }

    public static httpGetUnassignedOshWaveProtocolConfigurations(http: HttpClient,
        baseUrl: string,
        waveId: any,
        tthis?: any,
        callback?: any,
        callbackError?: any) {

        const url = baseUrl + Utils.getOshAPI() + '/waves/' + waveId + '/unassigned-protocols';
        http
            .get<any>(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (callbackError) {
                        callbackError(tthis, error);
                    }
                }
            })
    }

    public static httpAssignOshWaveProtocolConfigurations(http: HttpClient,
        baseUrl: string,
        waveId: any,
        ids: any,
        tthis?: any,
        callback?: any,
        callbackError?: any) {

        const url = baseUrl + Utils.getOshAPI() + '/waves/' + waveId + '/protocols';
        http
            .post<any>(url, { 'protocolIds': ids }).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (callbackError) {
                        callbackError(tthis, error);
                    }
                }
            })
    }

    public static httpImportOshProtocols(http: HttpClient,
        baseUrl: string,
        sourceWaveId: any,
        targetWaveId: any,
        tthis?: any,
        callback?: any,
        callbackError?: any) {

        const url = `${baseUrl}${Utils.getOshAPI()}/waves/import-protocols/${sourceWaveId}/${targetWaveId}`;
        http
            .post<any>(url, {}).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (callbackError) {
                        callbackError(tthis, error);
                    }
                }
            })
    }

    public static httpUnassignOshWaveProtocolConfigurations(http: HttpClient,
        baseUrl: string,
        waveId: any,
        ids: any,
        tthis?: any,
        callback?: any,
        callbackError?: any) {

        const url = baseUrl + Utils.getOshAPI() + '/waves/' + waveId + '/unassign-protocols';
        http
            .post<any>(url, { 'protocolIds': ids }).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (callbackError) {
                        callbackError(tthis, error);
                    }
                }
            })
    }

    // OSH Wave Branch Configuration
    public static httpGetOshWaveBranchConfigurations(http: HttpClient,
        baseUrl: string,
        waveId: any,
        tthis?: any,
        callback?: any,
        callbackError?: (context: any, error: any) => void) {

        const url = baseUrl + Utils.getOshAPI() + '/waves/' + waveId + '/branches';
        http
            .get<any>(url).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (callbackError) {
                        callbackError(tthis, error);
                    }
                }
            })
    }

    public static httpAssignOshWaveBranchConfigurations(http: HttpClient,
        baseUrl: string,
        waveId: any,
        ids: any,
        tthis?: any,
        callback?: any,
        callbackError?: (context: any, error: any) => void) {

        const url = baseUrl + Utils.getOshAPI() + '/waves/' + waveId + '/branches';
        http
            .post<any>(url, { 'mgmtIds': ids }).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (callbackError) {
                        callbackError(tthis, error);
                    }
                }
            })
    }

    public static httpUnassignOshWaveBranchConfigurations(http: HttpClient,
        baseUrl: string,
        waveId: any,
        ids: any,
        tthis?: any,
        callback?: any,
        callbackError?: (context: any, error: any) => void) {

        const url = baseUrl + Utils.getOshAPI() + '/waves/' + waveId + '/unassign-branches';
        http
            .post<any>(url, { 'mgmtIds': ids }).subscribe({
                next: (result) => {
                    if (tthis && callback)
                        callback(tthis, result);
                },
                error: (error) => {
                    Utils.writeLog(http, baseUrl, error);
                    if (callbackError) {
                        callbackError(tthis, error);
                    }
                }
            })
    }

    
}
